<template>
  <div>
    <PageHeader
      :title="`สร้างสินค้าแบบ import excel`"
      :items="itemsPageHeader"
    />
    <div class="card">
      <div class="card-body">
        <validationObserver ref="componentForm" tag="form">
          <form @submit.prevent="onSubmitVendor" @reset="onReset">
            <div class="pt-3">
              <!-- <div class="row">
              <div class="col-12">
                <div class="border-top pb-4"></div>
              </div>
            </div> -->
              <div class="row">
                <div class="col-12">
                  <div class="form-row form-group">
                    <label class="col-lg-4 col-xl-3 col-form-label" for="code"
                      >รหัสผู้ขาย</label
                    >
                    <div class="col-sm-4">
                      <validationProvider
                        v-slot="{ errors }"
                        name="code"
                        :rules="{ dynamicRequired: ['กรุณาระบุข้อมูล'] }"
                      >
                        <div role="group" class="input-group">
                          <input
                            id="code"
                            name="code"
                            type="text"
                            class="form-control"
                            v-model="vendorComponentModel.model.code"
                            :class="{ 'is-invalid': errors.length }"
                            :disabled="
                              dataPermissions.find(
                                f => f.name === 'vendor_information'
                              ).isEditable === false ||
                                (userInfo.user_type === 'Vendor' &&
                                  GET_VENDOR_SELECTED &&
                                  (GET_VENDOR_SELECTED.type === 'OFMStock' ||
                                    GET_VENDOR_SELECTED.type === 'DropShip'))
                            "
                          />
                          <span
                            class="input-group-append pointer"
                            @click="onSubmitVendor()"
                          >
                            <span
                              type="a"
                              class="input-group-text btn btn-light"
                            >
                              <i class="bx bx-search" />
                            </span>
                          </span>
                        </div>

                        <span
                          v-if="errors && errors.length"
                          class="validate-invalid"
                        >
                          {{ errors[0] }}
                        </span>
                      </validationProvider>
                    </div>
                  </div>
                  <div class="form-row">
                    <label
                      class="col-lg-4 col-xl-3 col-form-label"
                      for="display_name_th"
                      >ชื่อผู้ขาย</label
                    >
                    <div class="col-lg col-12 mt-auto mb-auto">
                      <span class="badge-lang">TH</span
                      >{{
                        vendorComponentModel.model.display_name &&
                        vendorComponentModel.model.display_name.th
                          ? vendorComponentModel.model.display_name.th
                          : '-'
                      }}
                    </div>
                  </div>
                  <div class="form-row">
                    <label
                      class="col-lg-4 col-xl-3 col-form-label"
                      for="display_name_en"
                    ></label>
                    <div class="col-lg col-12 mt-auto mb-auto">
                      <span class="badge-lang">EN</span>
                      {{
                        vendorComponentModel.model.display_name &&
                        vendorComponentModel.model.display_name.en
                          ? vendorComponentModel.model.display_name.en
                          : '-'
                      }}
                    </div>
                  </div>
                  <div class="form-row">
                    <label
                      class="col-lg-4 col-xl-3 col-form-label"
                      for="display_name_en"
                      >ประเภทผู้ขาย</label
                    >
                    <div class="col-lg col-12 mt-auto mb-auto">
                      <span
                        v-if="vendorComponentModel.model.vendor_type"
                        class="label"
                        :class="
                          'label-' +
                            vendorComponentModel.model.vendor_type.toLowerCase()
                        "
                        v-html="vendorComponentModel.model.vendor_type"
                      ></span>
                      <span v-else>-</span>
                    </div>
                  </div>
                  <div class="form-row">
                    <label
                      class="col-lg-4 col-xl-3 col-form-label"
                      for="display_name_en"
                      >สถานะผู้ขาย</label
                    >
                    <div class="col-lg col-12 mt-auto mb-auto">
                      <span
                        v-if="vendorComponentModel.model.vendor_status"
                        class="label"
                        :class="
                          'label-' +
                            vendorComponentModel.model.vendor_status.toLowerCase()
                        "
                        v-html="vendorComponentModel.model.vendor_status"
                      ></span>
                      <span v-else>-</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="pt-3">
            <div class="row">
              <div class="col-12">
                <div class="form-row form-group">
                  <label
                    class="col-lg-4 col-xl-3 col-form-label"
                    for="categories_hybrid"
                  >
                    Upload
                  </label>
                  <div class="col-sm-4">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <span class="input-group-text bg-transparent"
                          ><i class="bx bxs-folder-open"></i
                        ></span>
                      </div>
                      <b-form-file
                        placeholder="Choose file"
                        accept=".xls, .xlsx"
                        v-on:change="importExcel($event)"
                        v-model="file"
                        :disabled="isFirstLoad"
                      ></b-form-file>
                    </div>
                    <small class="form-text text-muted">
                      <b-spinner small v-if="disabledBtnUpload"> </b-spinner>
                      {{ disabledBtnUpload ? 'Loading...' : '' }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </validationObserver>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="card-body">
              <div class="row form-group">
                <div class="col-sm-12 col-md-9 mb-3">
                  <span class="color-green font-size-18 bold"
                    >ข้อมูลที่นำเข้าระบบได้</span
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <BkTable
                    :items="itemSuccess"
                    :fields="fields"
                    :options="optionsValid"
                    isTotalItems
                    @ClickPagination="onClickPagination($event, 'ri')"
                    @ChangePerPage="onChangePerPage($event, 'ri')"
                  >
                    <!-- |ู ตารางข้อมูลเปลี่ยนหน้า ลำดับไม่เปลี่ยนตาม -->
                    <!-- <template v-slot:cell(index)="data">
                          <div class="text-right">
                            {{ (data.index + 1) | number }}
                          </div>
                        </template> -->

                    <template v-slot:cell(action)="data">
                      <div class="text-center">
                        <a
                          @click="onDeleteitemSelect(data.item, true)"
                          class="btn btn-ico text-danger"
                          ><i class="bx bx-trash"></i
                        ></a>
                      </div>
                    </template>
                    <template v-slot:cell(group_id)="data">
                      <div
                        class="text-center"
                        v-if="data.item.ri_id && data.item.ri_id != ''"
                      >
                        <router-link
                          class="btn-ico text-primary"
                          title="Open approval document"
                          tag="a"
                          target="_blank"
                          :to="{
                            name: 'products_register_request',
                            params: { id: data.item.ri_id },
                          }"
                        >
                          {{ data.item.ri_id }}
                        </router-link>
                      </div>
                      <div class="text-center" v-else>
                        {{ data.item.group_id }}
                      </div>
                    </template>
                    <template v-slot:prepend-search
                      ><div class="text-right">
                        <b-button
                          @click="ExportExcelIR"
                          :disabled="
                            (dataTempExcelRI &&
                              dataTempExcelRI.filter(w => w.status != '201')
                                .length == 0) ||
                              itemSuccess.length == 0
                          "
                          ><i class="fas fa-file-export"></i>
                          Export Excel
                        </b-button>
                      </div></template
                    >

                    <template v-slot:cell(sku_count)="data">
                      <div class="text-center">
                        <b-button
                          variant="light"
                          @click="data.toggleDetails"
                          :style="
                            data.item.data_explain !== null &&
                            data.item.data_explain.some(
                              q => q.remark !== null && q.remark != ''
                            )
                              ? 'border: 1px solid red;'
                              : ''
                          "
                        >
                          <b-badge variant="info">{{
                            data.item.data_explain.length | number
                          }}</b-badge>
                          SKU
                          <i
                            :class="
                              data.detailsShowing
                                ? 'bx bx-caret-up'
                                : 'bx bx-caret-down'
                            "
                            title="More Detail"
                          ></i>
                        </b-button>
                      </div>
                    </template>

                    <template v-slot:row-details="data">
                      <!-- <b-card> -->
                      <b-table
                        class="table table-centered table-nowrap"
                        ref="grouptableCostCenter"
                        :empty-text="'Not found any result'"
                        :show-empty="
                          data.item.data_explain === null ||
                            data.item.data_explain === undefined ||
                            (data.item.data_explain &&
                              data.item.data_explain.length === 0)
                        "
                        :bordered="true"
                        :items="data.item.data_explain"
                        align="center"
                        v-bind:fields="fields_explain"
                      >
                        <template v-slot:cell(index)="data">
                          <div class="text-center">
                            {{ data.item.index | number }}
                          </div>
                        </template>
                        <template v-slot:cell(remark)="data">
                          <div
                            class="text-center"
                            v-if="data.item.remark == ''"
                          >
                            -
                          </div>
                          <div
                            class="text-center color-red"
                            v-else
                            v-for="(remark, i) in data.item.remark"
                            :key="`remark${i}`"
                          >
                            {{ remark }}
                          </div>
                        </template>
                        <template v-slot:cell(action)="d">
                          <div class="text-center">
                            <a
                              @click="
                                onDeleteSkuitemSelect(
                                  d.item,
                                  data.item.group_id,
                                  true
                                )
                              "
                              class="btn btn-ico text-danger"
                              ><i class="bx bx-trash"></i
                            ></a>
                          </div>
                        </template>
                      </b-table>
                    </template>
                  </BkTable>
                </div>
              </div>

              <div class="form-group mb-4 text-center">
                <div class="button-items">
                  <button
                    v-if="validateImportSuccess"
                    @click="onSave('ri')"
                    type="button"
                    class="btn btn-success"
                    :disabled="
                      itemSuccess.filter(w => w.ri_id == undefined).length == 0
                    "
                  >
                    Create RI
                  </button>
                  <button
                    @click="onClearItem('Success')"
                    type="button"
                    class="btn btn-light"
                  >
                    <i class="bx bx-reset" />Clear
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="card-body">
              <div class="row form-group">
                <div class="col-sm-12 col-md-9 mb-3">
                  <span class="color-red font-size-18 bold"
                    >ข้อมูลที่ไม่สามารถนำเข้าระบบได้</span
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <BkTable
                    :items="itemFailed"
                    :fields="fields"
                    :options="optionsValidDarft"
                    :isTotalItems="false"
                    @ClickPagination="onClickPagination($event, 'darft')"
                    @ChangePerPage="onChangePerPage($event, 'darft')"
                  >
                    <!-- |ู ตารางข้อมูลเปลี่ยนหน้า ลำดับไม่เปลี่ยนตาม -->
                    <!-- <template v-slot:cell(index)="data">
                          <div class="text-right">
                            {{ (data.index + 1) | number }}
                          </div>
                        </template> -->

                    <template v-slot:cell(action)="data">
                      <div class="text-center">
                        <a
                          @click="onDeleteitemSelect(data.item, false)"
                          class="btn btn-ico text-danger"
                          ><i class="bx bx-trash"></i
                        ></a>
                      </div>
                    </template>
                    <template v-slot:cell(group_id)="data">
                      <div
                        class="text-center"
                        v-if="data.item.np_id && data.item.np_id != ''"
                      >
                        <router-link
                          tag="a"
                          target="_blank"
                          title="Open Product Register Draft"
                          class="btn-ico text-primary"
                          :to="{
                            name: 'register-product-draft',
                            params: { id: data.item.np_id },
                            query: { mode: 'view' },
                          }"
                        >
                          {{ data.item.np_id }}
                        </router-link>
                      </div>
                      <div class="text-center" v-else>
                        {{ data.item.group_id }}
                        {{ data.item.np_id }}
                      </div>
                    </template>
                    <template v-slot:prepend-search
                      ><div class="text-right">
                        <b-button
                          @click="ExportExcelDarft"
                          :disabled="itemFailed && itemFailed.length == 0"
                          ><i class="fas fa-file-export"></i>
                          Export Excel
                        </b-button>
                      </div></template
                    >

                    <template v-slot:cell(sku_count)="data">
                      <div class="text-center">
                        <b-button
                          variant="light"
                          @click="data.toggleDetails"
                          :style="
                            data.item.data_explain !== null &&
                            data.item.data_explain.some(
                              q => q.remark !== null && q.remark != ''
                            )
                              ? 'border: 1px solid red;'
                              : ''
                          "
                        >
                          <b-badge variant="info">{{
                            data.item.data_explain.length | number
                          }}</b-badge>
                          SKU
                          <i
                            :class="
                              data.detailsShowing
                                ? 'bx bx-caret-up'
                                : 'bx bx-caret-down'
                            "
                            title="More Detail"
                          ></i>
                        </b-button>
                      </div>
                    </template>

                    <template v-slot:row-details="data">
                      <!-- <b-card> -->
                      <b-table
                        class="table table-centered table-nowrap"
                        ref="grouptableCostCenter"
                        :empty-text="'Not found any result'"
                        :show-empty="
                          data.item.data_explain === null ||
                            data.item.data_explain === undefined ||
                            (data.item.data_explain &&
                              data.item.data_explain.length === 0)
                        "
                        :bordered="true"
                        :items="data.item.data_explain"
                        align="center"
                        v-bind:fields="fields_explain"
                      >
                        <template v-slot:cell(index)="data">
                          <div class="text-center">
                            {{ data.item.index | number }}
                          </div>
                        </template>
                        <template v-slot:cell(remark)="data">
                          <div
                            class="text-center"
                            v-if="data.item.remark == ''"
                          >
                            -
                          </div>
                          <div
                            v-else
                            v-for="(remark, i) in data.item.remark"
                            :key="`remark${i}`"
                          >
                            <span class="color-red"
                              >{{ i + 1 }}. {{ remark }}</span
                            >
                          </div>
                        </template>
                        <template v-slot:cell(action)="d">
                          <div class="text-center">
                            <a
                              @click="
                                onDeleteSkuitemSelect(
                                  d.item,
                                  data.item.group_id,
                                  false
                                )
                              "
                              class="btn btn-ico text-danger"
                              ><i class="bx bx-trash"></i
                            ></a>
                          </div>
                        </template>
                      </b-table>
                    </template>
                  </BkTable>
                </div>
              </div>

              <div class="form-group mb-4 text-center">
                <div class="button-items">
                  <button
                    v-if="validateImportSuccess"
                    @click="onSave('darft')"
                    type="button"
                    class="btn btn-info"
                    :disabled="
                      itemFailed.filter(w => w.np_id == undefined).length == 0
                    "
                  >
                    SAVE DARFT
                  </button>

                  <button
                    @click="onClearItem('Failed')"
                    type="button"
                    class="btn btn-light"
                  >
                    <i class="bx bx-reset" />CLEAR
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col text-left">
      <button type="button" @click="onBack()" class="btn btn-light">
        <i class="bx bx-arrow-back" />
        Back
      </button>
    </div>

    <b-modal
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      centered
      id="modal-option-excel"
      title="Import Excel"
      size="xl"
    >
      <template #default="{ ok }">
        <div class="px-lg-10">
          <div class="row no-gutters">
            <template>
              <div class="table-responsive">
                <b-table
                  class="table table-centered table-nowrap"
                  ref="producttable_excel"
                  :bordered="true"
                  :filter="fields_poup"
                  :items="dataTempExcel"
                  align="center"
                  v-bind:fields="fields_poup"
                  :perPage="perPage"
                >
                  <template v-slot:cell(status)="data">
                    <div
                      class="text-center"
                      v-if="data.item.status == 'loading'"
                    >
                      <b-spinner
                        variant="primary"
                        label="Text Centered"
                      ></b-spinner>
                    </div>
                    <div
                      class="text-center"
                      v-if="
                        data.item.status != 'loading' && data.item.status != 201
                      "
                    >
                      <b-icon
                        icon="exclamation-circle-fill"
                        scale="2"
                        variant="danger"
                      ></b-icon>
                    </div>
                    <div
                      class="text-center color-green"
                      v-if="data.item.status == 201"
                    >
                      <b-icon icon="check" scale="2" variant="success"></b-icon>
                    </div>
                  </template>
                  <template v-slot:cell(action)="data">
                    <div v-if="data.item.status == 201" class="text-center">
                      <b-icon icon="check" scale="2" variant="success"></b-icon>
                    </div>
                    <div
                      v-else-if="data.item.status != 'loading'"
                      class="text-center"
                    >
                      <b-button
                        variant="warning"
                        @click="onRetryValidate(data.item)"
                        >Retry</b-button
                      >
                    </div>
                  </template>
                </b-table>
              </div>
            </template>
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      centered
      id="modal-option-excel-darft"
      title="Import Excel"
      size="xl"
    >
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action   ExportExcelDarft()-->
        <div>
          <h2>Import Excel</h2>
        </div>

        <b-icon icon="x" scale="2" @click="close()"></b-icon>
      </template>
      <template #default="{ ok }">
        <div class="px-lg-10">
          <div class="row no-gutters">
            <template>
              <div class="table-responsive">
                <b-table
                  class="table table-centered table-nowrap"
                  ref="producttable_excel"
                  :bordered="true"
                  :filter="fields_poup_darft"
                  :items="dataTempExcelDarft"
                  align="center"
                  v-bind:fields="fields_poup_darft"
                  :perPage="perPage"
                >
                  <template v-slot:cell(status)="data">
                    <div
                      class="text-center"
                      v-if="data.item.status == 'loading'"
                    >
                      <b-spinner
                        variant="primary"
                        label="Text Centered"
                      ></b-spinner>
                    </div>
                    <div
                      class="text-center"
                      v-if="
                        data.item.status != 'loading' && data.item.status != 201
                      "
                    >
                      <b-icon
                        icon="exclamation-circle-fill"
                        scale="2"
                        variant="danger"
                      ></b-icon>
                    </div>
                    <div
                      class="text-center color-green"
                      v-if="data.item.status == 201"
                    >
                      <b-icon icon="check" scale="2" variant="success"></b-icon>
                    </div>
                  </template>
                  <template v-slot:cell(action)="data">
                    <div v-if="data.item.status == 201" class="text-center">
                      <b-icon icon="check" scale="2" variant="success"></b-icon>
                    </div>
                    <div
                      v-else-if="data.item.status != 'loading'"
                      class="text-center"
                    >
                      <b-button
                        variant="warning"
                        @click="
                          onRetryRegisterDarft(data.item, data.item.group_id)
                        "
                        >Retry</b-button
                      >
                    </div>
                  </template>
                  <template v-slot:cell(group_id)="data" v-if="false">
                    <div v-if="data.item.status == 201" class="text-center">
                      {{ data.item.np_id }}
                    </div>
                  </template>
                </b-table>
              </div>
            </template>
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      centered
      id="modal-option-excel-ri"
      title="Import Excel"
      size="xl"
    >
      <template #default="{ ok }">
        <div class="px-lg-10">
          <div class="row no-gutters">
            <template>
              <div class="table-responsive">
                <b-table
                  class="table table-centered table-nowrap"
                  ref="producttable_excel"
                  :bordered="true"
                  :filter="fields_poup_ri"
                  :items="dataTempExcelRI"
                  align="center"
                  v-bind:fields="fields_poup_ri"
                  :perPage="perPage"
                >
                  <template v-slot:cell(status)="data">
                    <div
                      class="text-center"
                      v-if="data.item.status == 'loading'"
                    >
                      <b-spinner
                        variant="primary"
                        label="Text Centered"
                      ></b-spinner>
                    </div>
                    <div
                      class="text-center"
                      v-if="
                        data.item.status != 'loading' && data.item.status != 201
                      "
                    >
                      <b-icon
                        icon="exclamation-circle-fill"
                        scale="2"
                        variant="danger"
                      ></b-icon>
                    </div>
                    <div
                      class="text-center color-green"
                      v-if="data.item.status == 201"
                    >
                      <b-icon icon="check" scale="2" variant="success"></b-icon>
                    </div>
                  </template>
                  <template v-slot:cell(action)="data">
                    <div v-if="data.item.status == 201" class="text-center">
                      {{ data.item.status }}
                    </div>
                    <div
                      v-else-if="data.item.status != 'loading'"
                      class="text-center"
                    >
                      <b-button
                        variant="warning"
                        @click="onRetryCreatRI(data.item, data.item.key)"
                        >Retry</b-button
                      >
                    </div>
                  </template>
                </b-table>
              </div>
            </template>
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      centered
      :visible="loadingModelText === null ? false : true"
    >
      <div class="text-center p-4">
        <span class="loader">P&nbsp;M</span>
        <p class="loading h4 mt-2">
          {{ loadingModelText || 'Loading...' }}
        </p>
        <b-progress
          v-if="progressValue && progressValue > 0"
          :value="progressValue"
          :max="100"
          animated
        ></b-progress>
      </div>
    </b-modal>
  </div>
</template>
<script>
import AttributeSetSelect from '@/components/attributesets/selector'
import PageHeader from '@/components/page-header'
import AttributeValueSelect from '@/components/attributes/value-selector'
import { ExportFileName } from '@/helpers/utils/format-date.js'
import MappingHybridCategorySelector from '@/components/mappinghybridcategory/mapping-hybrid-category-selector'
import hybridCategoryService from '@/helpers/service/hybrid-category-service'
import attributesetsService from '@/helpers/service/attributesets-service'
import vendorService from '@/helpers/service/vendor-service'
import warehouseService from '@/helpers/service/warehouse-service'
import productRegisterDraftService from '@/helpers/service/product-register-draft-service'
import requestDocumentService from '@/helpers/service/request-document-service'
import brandService from '@/helpers/service/brand-service'
import unitService from '@/helpers/service/unit-service'
import attributeService from '@/helpers/service/attribute-service'
import colorService from '@/helpers/service/color-service'
import attributeSkuMechanicService from '@/helpers/service/attribute-sku-mechanic-service'
import productRegisterService from '@/helpers/service/product-register-service'
import Vue from 'vue'

import { authComputed } from '@/state/helpers'
import { getUserInfo } from '@/helpers/utils/jwt'

import XLSX from 'xlsx'
import { Workbook } from 'exceljs'
import * as fs from 'file-saver'
import { eventBus } from '@/main.js'
import { StatusEnum } from '@/enum/status.enum.js'
import { ToISOString } from '@/helpers/utils/format-date.js'
import BkTable from '@/components/share/bk-table'
import { Circle8 } from 'vue-loading-spinner'
import { v4 as uuidv4 } from 'uuid'
import { FormatQty } from '@/helpers/utils/format-qty.js'

export default {
  name: 'Attribute',
  components: {
    'attributeset-select': AttributeSetSelect,
    // 'attribute-value-select': AttributeValueSelect,
    'hybridcategory-selector': MappingHybridCategorySelector,
    BkTable,
    Circle8,
    PageHeader,
  },
  data() {
    return {
      itemsPageHeader: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'สร้างสินค้าแบบ Import Excel',
          active: true,
        },
      ],
      loadingModelText: null,
      progressValue: 0,
      isLoading: true,
      search: null,
      isReloadHybridCategorySelector: false,
      options_attributsets: [],
      isInternalSearch: true,
      isResetAfter: false,
      selectOptions: [],
      hybridCategoryItems: [],
      hybridCategoryId: '',
      isValidate: {
        hybridCategory: false,
      },
      vendorComponentModel: {
        collapseState: false,
        validateState: false,
        isPayloadChanged: false,
        model: {
          id: '',
          code: '',
          display_name: { en: '', th: '' },
          vendor_type: '',
          vendor_status: '',
          lead_time: 0,
          is_consignment: false,
          is_import: false,
          discount_rate_1: 0.0,
        },
      },
      permissions: [
        {
          name: 'vendor_information',
          ruleIDs: ['P3'],
          isEditable: false,
        },
      ],
      attributeComponentModel: {
        collapseState: false,
        validateState: false,
        isPayloadChanged: false,
        model: {
          id: '',
          display_name: { en: '', th: '' },
          attributes: [],
        },
      },
      fields: [
        {
          key: 'index',
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'group_id',
          label: 'รหัสกลุ่มสินค้า',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          key: 'product_name_th',
          label: 'ชื่อกลุ่มสินค้า (ไทย)',
          sortable: true,
        },
        {
          key: 'product_name_en',
          label: 'ชื่อกลุ่มสินค้า (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'brand_th',
          label: 'แบรนด์ (ไทย)',
          sortable: true,
        },
        {
          key: 'brand_en',
          label: 'แบรนด์ (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'series_th',
          label: 'รุ่น (ไทย)',
          sortable: true,
        },
        {
          key: 'series_en',
          label: 'รุ่น (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'sku_count',
          label: 'จำนวน SKU',
          sortable: true,
        },
        {
          key: 'action',
          label: 'Action',
          sortable: true,
        },
      ],
      fields_explain: [
        {
          key: 'index',
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        // {
        //   key: 'sku',
        //   label: 'รหัสสินค้า',
        //   thStyle: 'width:80px',
        //   sortable: true,
        // },
        {
          key: 'product_name_th',
          label: 'ชื่อสินค้า (ไทย)',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'product_name_en',
          label: 'ชื่อสินค้า (อังกฤษ)',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'remark',
          label: 'remark',
          sortable: true,
        },
        {
          key: 'action',
          label: 'action',
          thStyle: 'width: 160px',
          tdClass: 'text-center',
        },
      ],
      fields_poup: [
        {
          key: 'index',
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'group_id',
          label: 'รหัสกลุ่มสินค้า',
          sortable: true,
        },
        {
          key: 'product_name_th',
          label: 'ชื่อกลุ่มสินค้า (ไทย)',
          sortable: true,
        },
        {
          key: 'product_name_en',
          label: 'ชื่อกลุ่มสินค้า (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'status',
          label: 'สถานะ',
          sortable: true,
        },
        {
          key: 'action',
          label: 'action',
        },
      ],
      fields_poup_darft: [
        {
          key: 'index',
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'np_id',
          label: 'รหัสกลุ่มสินค้า',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'group_id',
          label: 'รหัสกลุ่มสินค้า',
          sortable: true,
        },
        {
          key: 'product_name_th',
          label: 'ชื่อกลุ่มสินค้า (ไทย)',
          sortable: true,
        },
        {
          key: 'product_name_en',
          label: 'ชื่อกลุ่มสินค้า (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'status',
          label: 'สถานะ',
          sortable: true,
        },
        {
          key: 'action',
          label: 'action',
        },
      ],
      fields_poup_ri: [
        {
          key: 'index',
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'ri_id',
          label: 'เลขที่อนุมัติ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'group_id',
          label: 'รหัสกลุ่มสินค้า',
          sortable: true,
        },
        {
          key: 'product_name_th',
          label: 'ชื่อกลุ่มสินค้า (ไทย)',
          sortable: true,
        },
        {
          key: 'product_name_en',
          label: 'ชื่อกลุ่มสินค้า (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'status',
          label: 'สถานะ',
          sortable: true,
        },
        {
          key: 'action',
          label: 'action',
        },
      ],
      excel: {
        head_data_validation: {
          brand_name: [],
          series_name: [],
          unit: [],
          color: [],
          material_type: [],
          capacity_gb: [],

          attribute_set: [],
          category_id: [],
          category_name: [],
        },
        optionsOfmStockInventoryStatus: [
          'ByOrder',
          'Control',
          'InStore',
          'Internal',
          'Limited',
          'New',
          'NonStock',
          'PreOrder',
          'Special',
          'Stock',
        ],
        optionsDropShipInventoryStatus: ['Hold', 'NonStock'],
        optionsFixPricePeriod: ['ไม่ยืนราคา', '3 เดือน', '6 เดือน', '12 เดือน'],
        optionsJDAStatus: ['A', 'I'],
        optionsSpecialType: ['C', 'S', 'M', 'O', 'R'],
        optionsDeliveryLeadTime: [
          '1-3',
          '3-7',
          '7-15',
          '15-30',
          '30-45',
          '45-90',
        ],
        opntionsFlag: ['Yes', 'No'],
        options_type: [
          'Book',
          'Computer',
          'Furniture',
          'Ink',
          'Office Automation',
          'MARKET PLACE',
        ],
        optionAging: ['0', '90', '120', '360'],
        option_sku_mechanic_default: [],
        warehouseOptions: [],
        header_excel_style_background: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '95b3d7' },
        },
        header_excel_style_background2: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '95b3d7' },
        },
        header_excel_style_background3: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'b8cce4' },
        },
        header_excel_style_background4: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'dce6f1' },
        },
        header_excel_style_font: {
          bold: true,
          size: 12,
          color: { argb: '000000' },
        },
        header_excel_style_font_mandatory: {
          bold: true,
          size: 12,
          color: { argb: 'cc0000' },
        },
        header_excel_ofm_stock_operator: [
          {
            key: 'business_unit',
            value: 'business_unit',
            option: 'กรุณาระบุโดยใส่ comma ขั้น ex. OFM,B2S',
            Mandatory: 'Mandatory',
          },
          {
            key: 'category_name',
            value: 'ชื่อหมวดหมู่',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'brand_name',
            value: 'แบรนด์',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'series_name_th',
            value: 'ซีรีส์ (ภาษาไทย)',
            option: 'หากเป็นสินค้าไม่มีรุ่นให้ระบุ Non-Series',
            Mandatory: 'Mandatory',
          },
          {
            key: 'series_name_en',
            value: 'ซีรีส์ (ภาษาอังกฤษ)',
            option: 'หากเป็นสินค้าไม่มีรุ่นให้ระบุ Non-Series',
            Mandatory: 'Mandatory',
          },
          {
            key: 'product_name_th',
            value: 'ชื่อสินค้าตั้งต้น (ภาษาไทย)',
            option:
              'ชื่อของสินค้าหรือชื่อของผลิตภัณฑ์เท่านั้น ไม่ระบุแบรนด์ รุ่น สี ขนาด',
            Mandatory: 'Mandatory',
          },
          {
            key: 'product_name_en',
            value: 'ชื่อสินค้าตั้งต้น (ภาษาอังกฤษ)',
            option:
              'ชื่อของสินค้าหรือชื่อของผลิตภัณฑ์เท่านั้น ไม่ระบุแบรนด์ รุ่น สี ขนาด',
            Mandatory: 'Mandatory',
          },
          {
            key: 'group_id',
            value: 'รหัสกลุ่ม',
            option: 'ระบุตัวเลขเดียวกันหากต้องการให้สินค้าอยู่กลุ่มเดียวกัน',
            Mandatory: 'Mandatory',
          },
          {
            key: 'unit',
            value: 'ตัวเลือกหน่วยสินค้า',
            option: 'กรุณาเลือกจากหน่วย',
            Mandatory: 'Mandatory',
          },
          {
            key: 'mechanic_2',
            value: 'ชื่อตัวเลือก 2',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_value_2',
            value: 'ค่าตัวเลือก 2',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_3',
            value: 'ชื่อตัวเลือก 3',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_value_3',
            value: 'ค่าตัวเลือก 3',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_4',
            value: 'ชื่อตัวเลือก 4',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_value_4',
            value: 'ค่าตัวเลือก 4',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'sku_code_jda',
            value: 'รหัสสินค้า JDA',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'sku_code_b2s',
            value: 'รหัสสินค้า JDA B2S',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'sku_code_vendor',
            value: 'รหัสสินค้าของผู้ขาย',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'barcode_vendor',
            value: 'barcode vendor',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'barcode_ofm',
            value: 'OFM barcode',
            option:
              'หากไม่ระบุข้อมูลและไม่มี barcode vendor ระบบจะสร้างให้ใหม่',
            Mandatory: 'Optional',
          },
          {
            key: 'is_vat',
            value: 'สินค้าคิดภาษี (Vat)',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'fix_price_period',
            value: 'ยืนราคา',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'discount_rate',
            value: 'ส่วนลดในตัว (%)',
            option: 'หากไม่กำหนดกรุณาระบุค่าเป็น 0',
            Mandatory: 'Optional',
          },
          {
            key: 'cost_price_exc_vat',
            value: 'ราคาทุน exc.vat',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'full_price_inc_vat',
            value: 'ราคาแนะนำขาย inc.vat',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'sale_price_inc_vat',
            value: 'ราคาขาย inc.vat',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_best_deal',
            value: 'สินค้า Best Deal',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'pack_size',
            value: 'ขั้นตํ่าในการเปิด PO',
            option: 'หากไม่ทราบกรุณาระบุค่าเป็น 1',
            Mandatory: 'Mandatory',
          },
          {
            key: 'limit_order_minimum',
            value: 'จำนวนขั้นต่ำต่อ order ของลูกค้า',
            option: 'หากไม่กำหนดกรุณาระบุค่าเป็น 0',
            Mandatory: 'Optional',
          },
          {
            key: 'limit_order_maximum',
            value: 'จำนวนสูงสุดต่อ order ของลูกค้า',
            option: 'หากไม่กำหนดกรุณาระบุค่าเป็น 0',
            Mandatory: 'Optional',
          },
          {
            key: 'product_status_inventory',
            value: 'สถานะสินค้า (OFM)',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'jda_status',
            value: 'สถานะสินค้า (JDA)',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'jda_special_type',
            value: 'สถานะเพิ่มเติม (JDA)',
            option: 'กรุณาระบุหากสถานะสินค้า (JDA) เป็น I',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_1',
            value: 'รูปสินค้า 1',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_2',
            value: 'รูปสินค้า 2',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_3',
            value: 'รูปสินค้า 3',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_4',
            value: 'รูปสินค้า 4',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_5',
            value: 'รูปสินค้า 5',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_6',
            value: 'รูปสินค้า 6',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_7',
            value: 'รูปสินค้า 7',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_8',
            value: 'รูปสินค้า 8',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_9',
            value: 'รูปสินค้า 9',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_10',
            value: 'รูปสินค้า 10',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'content_short_description_th',
            value: 'จุดขาย (ภาษาไทย)',
            option: 'ไม่เกิน 450 ตัวอักษร',
            Mandatory: 'Mandatory',
          },
          {
            key: 'content_short_description_en',
            value: 'จุดขาย (ภาษาอังกฤษ)',
            option: 'ไม่เกิน 450 ตัวอักษร',
            Mandatory: 'Mandatory',
          },
          {
            key: 'content_long_description_th',
            value: 'คำอธิบายแบบยาว (ภาษาไทย)',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'content_long_description_en',
            value: 'คำอธิบายแบบยาว (ภาษาอังกฤษ)',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'delivery_lead_time',
            value: 'ระยะเวลาในการจัดส่งสินค้าให้กับลูกค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'delivery_start_date',
            value: 'วันที่เริ่มจัดส่งสินค้า',
            option: 'รูปแบบวันที่ dd/MM/yyyy',
            Mandatory: 'Optional',
          },
          {
            key: 'weight_g',
            value: 'น้ำหนัก (กรัม)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'width_mm',
            value: 'ความกว้าง (มิลลิเมตร)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'length_mm',
            value: 'ความยาว (มิลลิเมตร)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'height_mm',
            value: 'ความสูง (มิลลิเมตร)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_ofm_delivery',
            value: 'จัดส่งสินค้าโดย OFM',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'warehouse',
            value: 'คลังสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'sub_warehouse',
            value: 'คลังสินค้าย่อย',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'has_new_product_fee',
            value: 'ค่าธรรมเนียมผลิตภัณฑ์ใหม่',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_return_to_vendor',
            value: 'การคืนสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'aging',
            value: 'ระยะเวลารับคืนสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'type',
            value: 'ชนิดสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_import',
            value: 'สินค้านำเข้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_bidding_price',
            value: 'สินค้าราคาประมูล',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_hamper',
            value: 'สินค้ากระเช้าต้องแยกจัดส่ง',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'has_consumer_protection',
            value: 'สินค้ามี สคบ.',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_virtual_stock',
            value: 'สินค้ามีการกำหนด stock เสมือน',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'pre_order_start_date',
            value: 'วันที่เริ่ม Pre-Order',
            option: 'รูปแบบวันที่ dd/MM/yyyy',
            Mandatory: 'Optional',
          },
          {
            key: 'pre_order_end_date',
            value: 'วันที่สิ้นสุด Pre-Order',
            option: 'รูปแบบวันที่ dd/MM/yyyy',
            Mandatory: 'Optional',
          },
          {
            key: 'vendor_remark',
            value: 'หมายเหตุสินค้าจาก Vendor',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'attribute_set',
            value: 'กลุ่มสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'attribute',
            value: '',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'document_file',
            value: 'เอกสารเพิ่มเติม',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'substitute',
            value: 'สินค้าทดแทน',
            option: '',
            Mandatory: 'Optional',
          },
        ],
        header_excel_ofm_stock_vendor: [
          {
            key: 'category_name',
            value: 'ชื่อหมวดหมู่',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'brand_name',
            value: 'แบรนด์',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'series_name_th',
            value: 'ซีรีส์ (ภาษาไทย)',
            option: 'หากเป็นสินค้าไม่มีรุ่นให้ระบุ Non-Series',
            Mandatory: 'Mandatory',
          },
          {
            key: 'series_name_en',
            value: 'ซีรีส์ (ภาษาอังกฤษ)',
            option: 'หากเป็นสินค้าไม่มีรุ่นให้ระบุ Non-Series',
            Mandatory: 'Mandatory',
          },
          {
            key: 'product_name_th',
            value: 'ชื่อสินค้าตั้งต้น (ภาษาไทย)',
            option:
              'ชื่อของสินค้าหรือชื่อของผลิตภัณฑ์เท่านั้น ไม่ระบุแบรนด์ รุ่น สี ขนาด',
            Mandatory: 'Mandatory',
          },
          {
            key: 'product_name_en',
            value: 'ชื่อสินค้าตั้งต้น (ภาษาอังกฤษ)',
            option:
              'ชื่อของสินค้าหรือชื่อของผลิตภัณฑ์เท่านั้น ไม่ระบุแบรนด์ รุ่น สี ขนาด',
            Mandatory: 'Mandatory',
          },
          {
            key: 'group_id',
            value: 'รหัสกลุ่ม',
            option: 'ระบุตัวเลขเดียวกันหากต้องการให้สินค้าอยู่กลุ่มเดียวกัน',
            Mandatory: 'Mandatory',
          },
          {
            key: 'unit',
            value: 'ตัวเลือกหน่วยสินค้า',
            option: 'กรุณาเลือกจากหน่วย',
            Mandatory: 'Mandatory',
          },
          {
            key: 'mechanic_2',
            value: 'ชื่อตัวเลือก 2',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_value_2',
            value: 'ค่าตัวเลือก 2',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_3',
            value: 'ชื่อตัวเลือก 3',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_value_3',
            value: 'ค่าตัวเลือก 3',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_4',
            value: 'ชื่อตัวเลือก 4',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_value_4',
            value: 'ค่าตัวเลือก 4',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'sku_code_vendor',
            value: 'รหัสสินค้าของผู้ขาย',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'barcode_vendor',
            value: 'barcode vendor',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'is_vat',
            value: 'สินค้าคิดภาษี (Vat)',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'discount_rate',
            value: 'ส่วนลดในตัว (%)',
            option: 'หากไม่กำหนดกรุณาระบุค่าเป็น 0',
            Mandatory: 'Optional',
          },
          {
            key: 'cost_price_exc_vat',
            value: 'ราคาทุน exc.vat',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'full_price_inc_vat',
            value: 'ราคาแนะนำขาย inc.vat',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'pack_size',
            value: 'ขั้นตํ่าในการเปิด PO',
            option: 'หากไม่ทราบกรุณาระบุค่าเป็น 1',
            Mandatory: 'Mandatory',
          },
          {
            key: 'image_url_1',
            value: 'รูปสินค้า 1',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_2',
            value: 'รูปสินค้า 2',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_3',
            value: 'รูปสินค้า 3',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_4',
            value: 'รูปสินค้า 4',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_5',
            value: 'รูปสินค้า 5',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_6',
            value: 'รูปสินค้า 6',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_7',
            value: 'รูปสินค้า 7',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_8',
            value: 'รูปสินค้า 8',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_9',
            value: 'รูปสินค้า 9',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_10',
            value: 'รูปสินค้า 10',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'content_short_description_th',
            value: 'จุดขาย (ภาษาไทย)',
            option: 'ไม่เกิน 450 ตัวอักษร',
            Mandatory: 'Mandatory',
          },
          {
            key: 'content_short_description_en',
            value: 'จุดขาย (ภาษาอังกฤษ)',
            option: 'ไม่เกิน 450 ตัวอักษร',
            Mandatory: 'Mandatory',
          },
          {
            key: 'content_long_description_th',
            value: 'คำอธิบายแบบยาว (ภาษาไทย)',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'content_long_description_en',
            value: 'คำอธิบายแบบยาว (ภาษาอังกฤษ)',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'weight_g',
            value: 'น้ำหนัก (กรัม)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'width_mm',
            value: 'ความกว้าง (มิลลิเมตร)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'length_mm',
            value: 'ความยาว (มิลลิเมตร)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'height_mm',
            value: 'ความสูง (มิลลิเมตร)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_return_to_vendor',
            value: 'การคืนสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'aging',
            value: 'ระยะเวลารับคืนสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_import',
            value: 'สินค้านำเข้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'vendor_remark',
            value: 'หมายเหตุสินค้าจาก Vendor',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'attribute_set',
            value: 'กลุ่มสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'attribute',
            value: '',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'document_file',
            value: 'เอกสารเพิ่มเติม',
            option: '',
            Mandatory: 'Optional',
          },
        ],
        header_excel_drop_ship_operator: [
          {
            key: 'business_unit',
            value: 'business_unit',
            option: 'กรุณาระบุโดยใส่ comma ขั้น ex. OFM,B2S',
            Mandatory: 'Mandatory',
          },
          {
            key: 'category_name',
            value: 'ชื่อหมวดหมู่',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'brand_name',
            value: 'แบรนด์',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'series_name_th',
            value: 'ซีรีส์ (ภาษาไทย)',
            option: 'หากเป็นสินค้าไม่มีรุ่นให้ระบุ Non-Series',
            Mandatory: 'Mandatory',
          },
          {
            key: 'series_name_en',
            value: 'ซีรีส์ (ภาษาอังกฤษ)',
            option: 'หากเป็นสินค้าไม่มีรุ่นให้ระบุ Non-Series',
            Mandatory: 'Mandatory',
          },
          {
            key: 'product_name_th',
            value: 'ชื่อสินค้าตั้งต้น (ภาษาไทย)',
            option:
              'ชื่อของสินค้าหรือชื่อของผลิตภัณฑ์เท่านั้น ไม่ระบุแบรนด์ รุ่น สี ขนาด',
            Mandatory: 'Mandatory',
          },
          {
            key: 'product_name_en',
            value: 'ชื่อสินค้าตั้งต้น (ภาษาอังกฤษ)',
            option:
              'ชื่อของสินค้าหรือชื่อของผลิตภัณฑ์เท่านั้น ไม่ระบุแบรนด์ รุ่น สี ขนาด',
            Mandatory: 'Mandatory',
          },
          {
            key: 'group_id',
            value: 'รหัสกลุ่ม',
            option: 'ระบุตัวเลขเดียวกันหากต้องการให้สินค้าอยู่กลุ่มเดียวกัน',
            Mandatory: 'Mandatory',
          },
          {
            key: 'unit',
            value: 'ตัวเลือกหน่วยสินค้า',
            option: 'กรุณาเลือกจากหน่วย',
            Mandatory: 'Mandatory',
          },
          {
            key: 'mechanic_2',
            value: 'ชื่อตัวเลือก 2',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_value_2',
            value: 'ค่าตัวเลือก 2',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_3',
            value: 'ชื่อตัวเลือก 3',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_value_3',
            value: 'ค่าตัวเลือก 3',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_4',
            value: 'ชื่อตัวเลือก 4',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_value_4',
            value: 'ค่าตัวเลือก 4',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'sku_code_jda',
            value: 'รหัสสินค้า JDA',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'sku_code_vendor',
            value: 'รหัสสินค้าของผู้ขาย',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'barcode_vendor',
            value: 'barcode vendor',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'barcode_ofm',
            value: 'OFM barcode',
            option:
              'หากไม่ระบุข้อมูลและไม่มี barcode vendor ระบบจะสร้างให้ใหม่',
            Mandatory: 'Optional',
          },
          {
            key: 'is_vat',
            value: 'สินค้าคิดภาษี (Vat)',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'full_price_inc_vat',
            value: 'ราคาแนะนำขาย inc.vat',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'sale_price_inc_vat',
            value: 'ราคาขาย inc.vat',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_best_deal',
            value: 'สินค้า Best Deal',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'limit_order_minimum',
            value: 'จำนวนขั้นต่ำต่อ order ของลูกค้า',
            option: 'หากไม่กำหนดกรุณาระบุค่าเป็น 0',
            Mandatory: 'Optional',
          },
          {
            key: 'limit_order_maximum',
            value: 'จำนวนสูงสุดต่อ order ของลูกค้า',
            option: 'หากไม่กำหนดกรุณาระบุค่าเป็น 0',
            Mandatory: 'Optional',
          },
          {
            key: 'product_status_inventory',
            value: 'สถานะสินค้า (OFM)',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'image_url_1',
            value: 'รูปสินค้า 1',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_2',
            value: 'รูปสินค้า 2',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_3',
            value: 'รูปสินค้า 3',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_4',
            value: 'รูปสินค้า 4',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_5',
            value: 'รูปสินค้า 5',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_6',
            value: 'รูปสินค้า 6',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_7',
            value: 'รูปสินค้า 7',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_8',
            value: 'รูปสินค้า 8',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_9',
            value: 'รูปสินค้า 9',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_10',
            value: 'รูปสินค้า 10',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'content_short_description_th',
            value: 'จุดขาย (ภาษาไทย)',
            option: 'ไม่เกิน 450 ตัวอักษร',
            Mandatory: 'Mandatory',
          },
          {
            key: 'content_short_description_en',
            value: 'จุดขาย (ภาษาอังกฤษ)',
            option: 'ไม่เกิน 450 ตัวอักษร',
            Mandatory: 'Mandatory',
          },
          {
            key: 'content_long_description_th',
            value: 'คำอธิบายแบบยาว (ภาษาไทย)',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'content_long_description_en',
            value: 'คำอธิบายแบบยาว (ภาษาอังกฤษ)',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'delivery_lead_time',
            value: 'ระยะเวลาในการจัดส่ง',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'weight_g',
            value: 'น้ำหนัก (กรัม)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'width_mm',
            value: 'ความกว้าง (มิลลิเมตร)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'length_mm',
            value: 'ความยาว (มิลลิเมตร)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'height_mm',
            value: 'ความสูง (มิลลิเมตร)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_return_to_vendor',
            value: 'การคืนสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'aging',
            value: 'ระยะเวลารับคืนสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_import',
            value: 'สินค้านำเข้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'has_consumer_protection',
            value: 'สินค้ามี สคบ.',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'product_remark',
            value: 'หมายเหตุสินค้า',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'attribute_set',
            value: 'กลุ่มสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'attribute',
            value: '',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'document_file',
            value: 'เอกสารเพิ่มเติม',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'substitute',
            value: 'สินค้าทดแทน',
            option: '',
            Mandatory: 'Optional',
          },
        ],
        header_excel_drop_ship_vendor: [
          {
            key: 'category_name',
            value: 'ชื่อหมวดหมู่',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'brand_name',
            value: 'แบรนด์',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'series_name_th',
            value: 'ซีรีส์ (ภาษาไทย)',
            option: 'หากเป็นสินค้าไม่มีรุ่นให้ระบุ Non-Series',
            Mandatory: 'Mandatory',
          },
          {
            key: 'series_name_en',
            value: 'ซีรีส์ (ภาษาอังกฤษ)',
            option: 'หากเป็นสินค้าไม่มีรุ่นให้ระบุ Non-Series',
            Mandatory: 'Mandatory',
          },
          {
            key: 'product_name_th',
            value: 'ชื่อสินค้าตั้งต้น (ภาษาไทย)',
            option:
              'ชื่อของสินค้าหรือชื่อของผลิตภัณฑ์เท่านั้น ไม่ระบุแบรนด์ รุ่น สี ขนาด',
            Mandatory: 'Mandatory',
          },
          {
            key: 'product_name_en',
            value: 'ชื่อสินค้าตั้งต้น (ภาษาอังกฤษ)',
            option:
              'ชื่อของสินค้าหรือชื่อของผลิตภัณฑ์เท่านั้น ไม่ระบุแบรนด์ รุ่น สี ขนาด',
            Mandatory: 'Mandatory',
          },
          {
            key: 'group_id',
            value: 'รหัสกลุ่ม',
            option: 'ระบุตัวเลขเดียวกันหากต้องการให้สินค้าอยู่กลุ่มเดียวกัน',
            Mandatory: 'Mandatory',
          },
          {
            key: 'unit',
            value: 'ตัวเลือกหน่วยสินค้า',
            option: 'กรุณาเลือกจากหน่วย',
            Mandatory: 'Mandatory',
          },
          {
            key: 'mechanic_2',
            value: 'ชื่อตัวเลือก 2',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_value_2',
            value: 'ค่าตัวเลือก 2',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_3',
            value: 'ชื่อตัวเลือก 3',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_value_3',
            value: 'ค่าตัวเลือก 3',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_4',
            value: 'ชื่อตัวเลือก 4',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'mechanic_value_4',
            value: 'ค่าตัวเลือก 4',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'sku_code_vendor',
            value: 'รหัสสินค้าของผู้ขาย',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'barcode_vendor',
            value: 'barcode vendor',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'is_vat',
            value: 'สินค้าคิดภาษี (Vat)',
            option: 'กรุณาเลือก',
            Mandatory: 'Mandatory',
          },
          {
            key: 'full_price_inc_vat',
            value: 'ราคาแนะนำขาย inc.vat',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'sale_price_inc_vat',
            value: 'ราคาขาย inc.vat',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'limit_order_minimum',
            value: 'จำนวนขั้นต่ำต่อ order ของลูกค้า',
            option: 'หากไม่กำหนดกรุณาระบุค่าเป็น 0',
            Mandatory: 'Optional',
          },
          {
            key: 'limit_order_maximum',
            value: 'จำนวนสูงสุดต่อ order ของลูกค้า',
            option: 'หากไม่กำหนดกรุณาระบุค่าเป็น 0',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_1',
            value: 'รูปสินค้า 1',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_2',
            value: 'รูปสินค้า 2',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_3',
            value: 'รูปสินค้า 3',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_4',
            value: 'รูปสินค้า 4',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_5',
            value: 'รูปสินค้า 5',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_6',
            value: 'รูปสินค้า 6',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_7',
            value: 'รูปสินค้า 7',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_8',
            value: 'รูปสินค้า 8',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_9',
            value: 'รูปสินค้า 9',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'image_url_10',
            value: 'รูปสินค้า 10',
            option: 'ระบุเป็น url ที่ฝากไฟล์ภาพไว้',
            Mandatory: 'Optional',
          },
          {
            key: 'content_short_description_th',
            value: 'จุดขาย (ภาษาไทย)',
            option: 'ไม่เกิน 450 ตัวอักษร',
            Mandatory: 'Mandatory',
          },
          {
            key: 'content_short_description_en',
            value: 'จุดขาย (ภาษาอังกฤษ)',
            option: 'ไม่เกิน 450 ตัวอักษร',
            Mandatory: 'Mandatory',
          },
          {
            key: 'content_long_description_th',
            value: 'คำอธิบายแบบยาว (ภาษาไทย)',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'content_long_description_en',
            value: 'คำอธิบายแบบยาว (ภาษาอังกฤษ)',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'delivery_lead_time',
            value: 'ระยะเวลาในการจัดส่ง',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'weight_g',
            value: 'น้ำหนัก (กรัม)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'width_mm',
            value: 'ความกว้าง (มิลลิเมตร)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'length_mm',
            value: 'ความยาว (มิลลิเมตร)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'height_mm',
            value: 'ความสูง (มิลลิเมตร)',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_return_to_vendor',
            value: 'การคืนสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'aging',
            value: 'ระยะเวลารับคืนสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'is_import',
            value: 'สินค้านำเข้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'product_remark',
            value: 'หมายเหตุสินค้า',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'attribute_set',
            value: 'กลุ่มสินค้า',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'attribute',
            value: '',
            option: '',
            Mandatory: 'Mandatory',
          },
          {
            key: 'document_file',
            value: 'เอกสารเพิ่มเติม',
            option: '',
            Mandatory: 'Optional',
          },
          {
            key: 'substitute',
            value: 'สินค้าทดแทน',
            option: '',
            Mandatory: 'Optional',
          },
        ],
        header_excel_ofm_stock: [
          {
            key: 'brand_name',
            value: 'แบรนด์',
          },
          {
            key: 'series_name_th',
            value: 'ซีรีส์ (ไทย)',
          },
          {
            key: 'series_name_en',
            value: 'ซีรีส์ (ภาษาอังกฤษ)',
          },
          {
            key: 'product_name_th',
            value: 'ชื่อสินค้า (ภาษาไทย)',
          },
          {
            key: 'product_name_en',
            value: 'ชื่อสินค้า (ภาษาอังกฤษ)',
          },
          {
            key: 'unit',
            value: 'หน่วยสินค้า',
          },
          {
            key: 'color',
            value: 'สี',
          },
          {
            key: 'size',
            value: 'ขนาด',
          },
          {
            key: 'smell',
            value: 'กลิ่น',
          },
          {
            key: 'taste',
            value: 'รสชาติ',
          },
          {
            key: 'capacity_liter',
            value: 'ปริมาตร  (ลิตร)',
          },
          {
            key: 'material_type',
            value: 'ชนิดของวัสดุ',
          },
          {
            key: 'capacity_gb',
            value: 'ความจุ',
          },
          {
            key: 'vendor_sku_code',
            value: 'รหัสสินค้าของผู้ขาย',
          },
          {
            key: 'bar_code',
            value: 'barcode',
          },
          {
            key: 'original_cost',
            value: 'ราคาทุน',
          },
          {
            key: 'retail_price',
            value: 'ราคาแนะนำขาย',
          },
          {
            key: 'quantity_standard_pack_maximum',
            value: 'ขั้นต่ำในการเปิด PO',
          },
          {
            key: 'content_short_description',
            value: 'จุดขาย',
          },
          {
            key: 'weight_kg',
            value: 'น้ำหนัก (กิโลกรัม)',
          },
          {
            key: 'width_cm',
            value: 'ความกว้าง (เซ็นติเมตร)',
          },
          {
            key: 'length_cm',
            value: 'ความยาว (เซ็นติเมตร)',
          },
          {
            key: 'height_cm',
            value: 'ความสูง (เซ็นติเมตร)',
          },
          {
            key: 'attribute_set',
            value: 'กลุ่มสินค้า',
          },
          // {
          //   key: 'category_id',
          //   value: 'รหัสหมวดหมุ่',
          // },
          {
            key: 'category_name',
            value: 'ชื่อหมวดหมู่ss',
          },
        ],
        header_excel_drop_ship: [
          {
            key: 'brand_name',
            value: 'แบรนด์',
          },
          {
            key: 'series_name_th',
            value: 'ซีรีส์ (ไทย)',
          },
          {
            key: 'series_name_en',
            value: 'ซีรีส์ (ภาษาอังกฤษ)',
          },
          {
            key: 'product_name_th',
            value: 'ชื่อสินค้า (ภาษาไทย)',
          },
          {
            key: 'product_name_en',
            value: 'ชื่อสินค้า (ภาษาอังกฤษ)',
          },
          {
            key: 'unit',
            value: 'หน่วยสินค้า',
          },
          {
            key: 'color',
            value: 'สี',
          },
          {
            key: 'size',
            value: 'ขนาด',
          },
          {
            key: 'smell',
            value: 'กลิ่น',
          },
          {
            key: 'taste',
            value: 'รสชาติ',
          },
          {
            key: 'capacity_liter',
            value: 'ปริมาตร  (ลิตร)',
          },
          {
            key: 'material_type',
            value: 'ชนิดของวัสดุ',
          },
          {
            key: 'capacity_gb',
            value: 'ความจุ',
          },
          {
            key: 'vendor_sku_code',
            value: 'รหัสสินค้าของผู้ขาย',
          },
          {
            key: 'bar_code',
            value: 'barcode',
          },
          {
            key: 'retail_price',
            value: 'ราคาแนะนำขาย',
          },
          {
            key: 'sale_price',
            value: 'ราคาขาย',
          },
          {
            key: 'limit_order_minimum',
            value: 'ขั้นต่ำในการสั่งซื้อ',
          },
          {
            key: 'limit_order_maximum',
            value: 'จำนวนสูงสุดในการสั่งซื้อ',
          },
          {
            key: 'content_short_description',
            value: 'จุดขาย',
          },
          {
            key: 'weight_kg',
            value: 'น้ำหนัก (กิโลกรัม)',
          },
          {
            key: 'width_cm',
            value: 'ความกว้าง (เซ็นติเมตร)',
          },
          {
            key: 'length_cm',
            value: 'ความยาว (เซ็นติเมตร)',
          },
          {
            key: 'height_cm',
            value: 'ความสูง (เซ็นติเมตร)',
          },
          {
            key: 'attribute_set',
            value: 'กลุ่มสินค้า',
          },
          // {
          //   key: 'category_id',
          //   value: 'รหัสหมวดหมุ่',
          // },
          {
            key: 'category_name',
            value: 'ชื่อหมวดหมู่',
          },
        ],
        template_file_name: 'RegisterProductTemplate',
      },
      file: [],
      categorySelect: '',
      attributeSetSelect: '',
      isFirstWatchValue: true,
      tempDefailtValue: [],
      pageNo: 1,
      totalPages: 0,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
      totalRecords: 0,
      perPage: 9999,
      items: [],
      itemImportTmp: [],
      validateImportSuccess: false,
      brandDefault: [],
      unitDefault: [],
      materialTypeDefault: [],
      capacityDefault: [],
      colorDefault: [],
      attributeSetGroupProductSelectList: [],
      option_sku_mechanic_default: [],
      itemSuccess: [],
      itemFailed: [],
      dataTempExcel: [],
      dataTempExcelDarft: [],
      dataTempExcelRI: [],
      isLoadValidate: false,
      pageOptions: [5, 10, 25, 50, 100],
      perPageFailed: 10,
      perPageSuccess: 10,
      optionsValid: {
        pageNo: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRecords: null,
      },
      optionsValidDarft: {
        pageNo: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRecords: null,
      },
      flagModal: 'validate',
      tempWorkbook: [],
      alpha: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
      attributeListDistinct: [],
      isMandatory: 'true',
      disabledBtnUpload: false,
      isFirstLoad: true,
    }
  },
  created() {},
  async mounted() {
    if (
      this.userInfo.user_type === 'Vendor' &&
      this.GET_VENDOR_SELECTED &&
      (this.GET_VENDOR_SELECTED.type === 'OFMStock' ||
        this.GET_VENDOR_SELECTED.type === 'DropShip')
    ) {
      await this.onGetVendorByIdAsync()
      await this.onGetDataExportExcel()
      this.isFirstLoad = false
    }
  },
  watch: {
    'attributeComponentModel.model': {
      handler(val) {
        if (val) {
          // console.log('sssssssss')
          // console.log(val)

          this.attributeSetSelect = `${val.display_name.en} : ${val.display_name.th}`
        }
      },
      deep: true,
    },
    // value: {
    //   handler(val) {
    //     if (this.isFirstWatchValue) {
    //       console.log('isFirstWatchValue', this.isFirstWatchValue)
    //       this.isFirstWatchValue = false
    //       this.attributeComponentModel = val
    //       if (
    //         this.attributeComponentModel.model &&
    //         this.attributeComponentModel.model.attributes &&
    //         this.attributeComponentModel.model.attributes.length > 0
    //       ) {
    //         this.isFirstWatchValue = false
    //         this.attributeComponentModel.model.attributes.forEach(element => {
    //           if (
    //             element &&
    //             element.data_values &&
    //             element.data_values.length > 0
    //           ) {
    //             element.value = element.data_values.find(
    //               f => f.en === element.value.en && f.th === element.value.th
    //             )
    //           }
    //         })
    //       }
    //     }
    //   },
    //   deep: true,
    // },
    GET_VENDOR_SELECTED: {
      handler(val) {
        if (
          this.userInfo.user_type === 'Vendor' &&
          this.GET_VENDOR_SELECTED &&
          (this.GET_VENDOR_SELECTED.type === 'OFMStock' ||
            this.GET_VENDOR_SELECTED.type === 'DropShip')
        ) {
          this.onGetVendorByIdAsync()
        }
      },
      deep: true,
    },
  },
  computed: {
    ...authComputed,
    userInfo() {
      if (this.getAccessToken !== null) {
        return getUserInfo(this.getAccessToken)
      } else return {}
    },
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        //Vendor Information จะมีเพียง P3 เท่านั้น
        permissions = this.processActionMapping(permissions, 'P3')
      } else {
        permissions.forEach(element => {
          element.isEditable = true
        })
      }
      return permissions
    },
  },
  methods: {
    // modelChanged() {
    //   this.attributeComponentModel.isPayloadChanged = true
    //   this.$emit('input', this.attributeComponentModel)
    // },
    onBack() {
      this.$router.push({
        path: '/product/registers',
      })
    },
    onSubmitVendor() {
      this.$refs.componentForm.validate().then(result => {
        if (result) {
          this.onGetVendorDataAsync()
        } else {
          this.vendorComponentModel.validateState = false
        }
        // this.modelChanged()
      })
    },
    onReset() {},
    async onGetAttributeSkuMechanicSelector(isWatch) {
      let params = new URLSearchParams()
      params.append('pageSize', 99999)
      params.append('sort', 'display_name.th display_name.en')
      params.append('status', StatusEnum.ACTIVE)
      params.append('isGetIncludeDatabaseValue', true)

      let result = await attributeSkuMechanicService.getAttributeSkuMechanicMasterListAsync(
        params
      )
      console.log('onGetAttributeSkuMechanicSelector', result)
      if (
        result.status === 200 &&
        result.data.items &&
        result.data.items.length > 0
      ) {
        let attributSkuMechanicItems = []
        result.data.items
          .sort((a, b) => (a.display_name.th > b.display_name.th ? 1 : -1))
          .forEach((element, index) => {
            attributSkuMechanicItems[index] = {
              id: element.id,
              display_name: {
                th: element.display_name ? element.display_name.th : '',
                en: element.display_name ? element.display_name.en : '',
              },
              type: element.type,
              collection: element.collection,
              values: [
                {
                  id: element.type === 'FreeText' ? this.genHexString(24) : '',
                  display_name: { en: '', th: '' },
                },
              ],
              option_values: element.values
                .sort((a, b) =>
                  a.display_name.th > b.display_name.th ? 1 : -1
                )
                .map(m => {
                  return { id: m._id, display_name: m.display_name }
                }),
              $isDisabled:
                (element.display_name ? element.display_name.en : '') == 'Unit'
                  ? true
                  : false,
            }
          })
        console.log('attributSkuMechanicItems', attributSkuMechanicItems)
        this.option_sku_mechanic_default = attributSkuMechanicItems
        console.log(
          'attributSkuMechanicItems',
          this.option_sku_mechanic_default
        )
      } else {
        if (result.response.data.message) {
          console.log(result.response.data.message)
        }
      }
    },
    genHexString(len) {
      const hex = '0123456789abcdef'
      let output = ''
      for (let i = 0; i < len; ++i) {
        output += hex.charAt(Math.floor(Math.random() * hex.length))
      }
      return output
    },
    async onGetColorSelector() {
      let params = new URLSearchParams()
      params.append('pageSize', 999999)
      params.append('sort', 'create_info.timestamp')
      params.append('status', StatusEnum.ACTIVE)

      let result = await colorService.getColorMasterListAsync(params)
      if (result.status === 200) {
        result.data.items
          .sort((a, b) => (a.display_name.th > b.display_name.th ? 1 : -1))
          .forEach((element, index) => {
            let tempColor = {
              id: element.id,
              display_name: {
                th: element.display_name.th,
                en: element.display_name.en,
              },
            }
            this.colorDefault.push(tempColor)
          })
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log('error', result.response.data.message)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onGetAttributeSelector(keyword) {
      let params = new URLSearchParams()
      params.append('pageSize', 999999)
      params.append('keyword', keyword)
      params.append('sort', 'create_info.timestamp')
      params.append('status', StatusEnum.ACTIVE)
      let result = await attributeService.getAttributeMasterListAsync(params)
      if (result.status === 200) {
        if (result.data.items.length > 0) {
          result.data.items[0].data_values
            .sort((a, b) => (a.value.th > b.value.th ? 1 : -1))
            .forEach((element, index) => {
              console.log('onGetAttributeSelector', element)
              let tempAttribute = {
                id: element.id,
                display_name: {
                  th: element.display_name.th,
                  en: element.display_name.en,
                },
              }
              if (keyword === 'ชนิดของวัสดุ') {
                this.materialTypeDefault.push(tempAttribute)
              } else if (keyword === 'ความจุ') {
                this.capacityDefault.push(tempAttribute)
              }
            })
        }
      }
    },
    async getHybridCategory() {
      let params = new URLSearchParams()
      params.append('isControlProduct', true)
      params.append('status', StatusEnum.ACTIVE)
      let result = await hybridCategoryService.getMappingHybridCategoryTreeNodeAsync(
        params
      )

      if (result.status === 200) {
        if (result.data && result.data.length > 0) {
          this.hybridCategoryItems = result.data
        }
      }
    },
    async onHybridCategorySelector(obj) {
      this.hybridCategoryId = obj.id
      this.isValidate.hybridCategory = false
      this.categorySelect = ''
      if (obj && obj.value && obj.value.length > 0) {
        obj.value.forEach((item, index) => {
          this.categorySelect +=
            obj.value.length !== index + 1
              ? `${item.displayName} > `
              : `${item.displayName}`
        })
      }
    },
    async onGetUnitSelector() {
      let params = new URLSearchParams()
      params.append('pageSize', 999999)
      params.append('sort', 'create_info.timestamp')
      params.append('status', StatusEnum.ACTIVE)

      let result = await unitService.getUnitMasterListAsync(params)
      if (result.status === 200) {
        result.data.items
          .sort((a, b) => (a.display_name.th > b.display_name.th ? 1 : -1))
          .forEach((element, index) => {
            let tempUnit = {
              id: element.id,
              display_name: {
                th: element.display_name.th,
                en: element.display_name.en,
              },
            }
            this.unitDefault.push(tempUnit)
          })
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log('error', result.response.data.message)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onGetBrandSelector() {
      this.options = []
      let params = new URLSearchParams()
      params.append('pageSize', 999999)
      params.append('sort', 'create_info.timestamp')
      params.append('status', StatusEnum.ACTIVE)
      let result = await brandService.getBrandMasterListAsync(params)
      if (result.status === 200) {
        result.data.items
          .sort((a, b) => (a.display_name.th > b.display_name.th ? 1 : -1))
          .forEach((element, index) => {
            let tempBrand = {
              id: element.id,
              display_name: element.display_name,
            }
            this.brandDefault.push(tempBrand)
          })
      } else {
        if (result.response.data.message) {
          console.log(result.response.data.message)
        } else {
          console.log('Bad request: Unkonw error')
        }
      }
    },
    async onRetryValidate(item) {
      item.status = 'loading'
      let key = item.temp.id
      let dataPlayload = item.temp.playload
      var result = await this.validateImportDataExcel2(dataPlayload)
      let temp = {
        id: key,
        response: result,
        playload: dataPlayload,
      }
      item.status = result.status
      item.temp = temp
      item.response = result

      if (result.status == 201) {
        let dataPlayload_0 = item.temp.playload[0]
        let data_explain = []
        for (var ii = 0; ii < result.data.length; ii++) {
          let dataPlatload = item.temp.playload[ii]
          let mechanics_th = ''
          let mechanics_en = ''
          if (
            dataPlatload.sku_mechanics &&
            dataPlatload.sku_mechanics.length > 0
          ) {
            dataPlatload.sku_mechanics.forEach(mac => {
              if (mac.value.display_name) {
                mechanics_th =
                  mechanics_th + ' ' + mac.value.display_name.th + ' '
                mechanics_en =
                  mechanics_en + ' ' + mac.value.display_name.en + ' '
              }
            })
          }

          let temp_explain = {
            index: ii + 1,
            sku: '',
            product_name_th:
              dataPlayload_0.product_name.display_name.th + mechanics_th,
            product_name_en:
              dataPlayload_0.product_name.display_name.en + mechanics_en,
            remark: result.data[ii].message,
          }
          data_explain.push(temp_explain)
        }

        let tempItem = {
          group_id: key,
          product_name_th: dataPlayload_0.product_name.display_name.th,
          product_name_en: dataPlayload_0.product_name.display_name.en,
          brand_th: dataPlayload_0.brand_name.display_name.th,
          brand_en: dataPlayload_0.brand_name.display_name.en,
          series_th: dataPlayload_0.series_name.display_name.th,
          series_en: dataPlayload_0.series_name.display_name.en,
          sku_count: item.temp.playload.length,
          data_explain: data_explain,
          data_temp: item.temp.playload,
        }
        if (result.data.some(w => w.message != null && w.message.length > 0)) {
          //TODOO Failed
          this.itemFailed.push(tempItem)
        } else {
          //TODOO Success
          this.itemSuccess.push(tempItem)
        }
      }
      if (!this.dataTempExcel.some(w => w.status != '201')) {
        this.$bvModal.hide('modal-option-excel')
      }
    },
    async onRetryRegisterDarft(item, group_id) {
      //
      console.log('onRetryRegisterDarft', item)
      item.status = 'loading'
      var params = {
        vendor_id: this.vendorComponentModel.model.id,
        product_details: item.temp.data_temp,
      }
      var result = null
      if (this.vendorComponentModel.model.vendor_type === 'OFMStock') {
        result = await productRegisterDraftService.createProductRegisterDraftsImportOFMStockAsync(
          params
        )
      } else {
        result = await productRegisterDraftService.createProductRegisterDraftsImportDropShipAsync(
          params
        )
      }
      console.log('onRetryRegisterDarft result', result.status)

      item.status = result.status
      item.response = result
      if (result.status == 201) {
        item.np_id = result.data.np_id

        let itemFaild = this.itemFailed.find(w => w.group_id == group_id)
        if (itemFaild && itemFaild != undefined) {
          Vue.set(itemFaild, 'np_id', result.data.np_id)
          //itemFaild.np_id = result.data.np_id
        }
      }

      if (!this.dataTempExcelDarft.some(w => w.status != '201')) {
        this.$bvModal.hide('modal-option-excel-darft')
      }
    },
    async onRetryCreatRI(item, key) {
      console.log('onRetryCreatRI', item)
      item.status = 'loading'
      var params = {
        vendor_id: this.vendorComponentModel.model.id,
        product_details: item.temp.data_temp,
        vendor_code: this.vendorComponentModel.model.code,
      }
      var result = await productRegisterService.createImportApproveProductRegisterAsync(
        params
      )
      console.log('onRetryCreatRI result', result)

      item.status = result.status
      item.response = result
      if (result.status == 201) {
        item.ri_id = result.data.id

        let itemSuccess = this.itemSuccess.find(w => w.key == key)
        if (itemSuccess && itemSuccess != undefined) {
          Vue.set(itemSuccess, 'ri_id', result.data.id)
          //itemSuccess.ri_id = result.data.id
        }
      }

      if (!this.dataTempExcelRI.some(w => w.status != '201')) {
        this.$bvModal.hide('modal-option-excel-ri')
      }
    },
    async onDeleteitemSelect(item, successItem) {
      if (!successItem) {
        const index = this.itemFailed.indexOf(item)
        if (index > -1) {
          this.itemFailed.splice(index, 1)
        }
      } else {
        const index = this.itemSuccess.indexOf(item)
        if (index > -1) {
          this.itemSuccess.splice(index, 1)
        }
      }
    },
    async onDeleteSkuitemSelect(item, group_id, successItem) {
      if (successItem) {
        let itemSuccess = this.itemSuccess.find(w => w.group_id == group_id)
        if (itemSuccess && itemSuccess != undefined) {
          const index = itemSuccess.data_explain.indexOf(item)
          if (index > -1) {
            itemSuccess.data_explain.splice(index, 1)
          }
          if (
            !itemSuccess.data_explain ||
            itemSuccess.data_explain.length == 0
          ) {
            const index = this.itemSuccess.indexOf(itemSuccess)
            if (index > -1) {
              this.itemSuccess.splice(index, 1)
            }
          }
        }
      } else {
        let itemFailed = this.itemFailed.find(w => w.group_id == group_id)
        if (itemFailed && itemFailed != undefined) {
          const index = itemFailed.data_explain.indexOf(item)
          if (index > -1) {
            itemFailed.data_explain.splice(index, 1)
          }
          if (!itemFailed.data_explain || itemFailed.data_explain.length == 0) {
            const index = this.itemFailed.indexOf(itemFailed)
            if (index > -1) {
              this.itemFailed.splice(index, 1)
            }
          }
        }
      }
    },
    async ExportExcelDarft() {
      var vm = this
      let dataToExport = this.itemFailed
      if (dataToExport && dataToExport.length > 0) {
        const task = async () => {
          console.log('Task started!')
          this.loadingModelText = 'กำลังเตรียมไฟล์...'
          await new Promise(resolve =>
            setTimeout(async () => {
              await this.onDownloadTemplate('darft')
              resolve()
            }, 1000)
          )
          console.log('Task completed!')
        }

        task().then(() => {
          vm.loadingModelText = null
        })
      }
    },
    async ExportExcelIR() {
      var vm = this
      let dataToExport = this.dataTempExcelRI.filter(w => w.status != '201')
      if (dataToExport && dataToExport.length > 0) {
        const task = async () => {
          console.log('Task started!')
          this.loadingModelText = 'กำลังเตรียมไฟล์...'
          await new Promise(resolve =>
            setTimeout(async () => {
              console.log('Task executed!')
              await this.onDownloadTemplate('ri')
              resolve()
            }, 1000)
          )
          console.log('Task completed!')
        }

        task().then(() => {
          vm.loadingModelText = null
        })
      }
    },
    async importExcel(e) {
      this.flagModal = 'validate'
      this.itemSuccess = []
      this.itemFailed = []
      var vm = this
      vm.dataTempExcel = []
      vm.dataTempExcelDarft = []
      vm.dataTempExcelRI = []
      vm.attributeListDistinct = []
      var selectedFile = e.target.files[0]
      vm.file = []
      let headExcel = []
      console.log(this.vendorComponentModel.model.vendor_type + ' xxx-------')

      var reader = new FileReader()
      reader.onload = function(event) {
        var data = event.target.result
        var workbook = XLSX.read(data, {
          type: 'binary',
        })

        var seqKeys = []
        var isValidateFormat = false
        let isEmtryData = false
        workbook.SheetNames.forEach(function(sheetName) {
          if (sheetName === 'Template' || sheetName === 'Data') {
            var row = XLSX.utils.sheet_to_row_object_array(
              workbook.Sheets[sheetName]
            )
            console.log(
              '🚀 ~ file: import-excel.vue:3263 ~ workbook.SheetNames.forEach ~ row:',
              row
            )

            if (!row || row.length < 4) {
              isEmtryData = true
            }

            let headerKeys = Object.keys(row[0])
            let countCheck = 1
            let keyErrors = []

            let haveDiscountRate = false
            let haveBussiness = false

            headerKeys.forEach(item => {
              var findObj = undefined

              if (item == 'discount_rate') {
                haveDiscountRate = true
              }
              if (item == 'business_unit') {
                haveBussiness = true
              }
              if (vm.vendorComponentModel.model.vendor_type === 'OFMStock') {
                if (
                  vm.userInfo.user_type === 'Vendor' &&
                  vm.GET_VENDOR_SELECTED &&
                  (vm.GET_VENDOR_SELECTED.type === 'OFMStock' ||
                    vm.GET_VENDOR_SELECTED.type === 'DropShip')
                ) {
                  //TODOO Vendor
                  findObj = vm.excel.header_excel_ofm_stock_vendor.find(
                    x => x.key === item
                  )
                  headExcel = vm.excel.header_excel_ofm_stock_vendor.map(
                    m => m.key
                  )
                } else {
                  //TODOO Operator
                  findObj = vm.excel.header_excel_ofm_stock_operator.find(
                    x => x.key === item
                  )
                  headExcel = vm.excel.header_excel_ofm_stock_operator.map(
                    m => m.key
                  )
                }
              } else {
                if (
                  vm.userInfo.user_type === 'Vendor' &&
                  vm.GET_VENDOR_SELECTED &&
                  (vm.GET_VENDOR_SELECTED.type === 'OFMStock' ||
                    vm.GET_VENDOR_SELECTED.type === 'DropShip')
                ) {
                  //TODOO Vendor
                  findObj = vm.excel.header_excel_drop_ship_vendor.find(
                    x => x.key === item
                  )
                  headExcel = vm.excel.header_excel_drop_ship_vendor.map(
                    m => m.key
                  )
                } else {
                  //TODOO Operator
                  findObj = vm.excel.header_excel_drop_ship_operator.find(
                    x => x.key === item
                  )
                  headExcel = vm.excel.header_excel_drop_ship_operator.map(
                    m => m.key
                  )
                }
              }

              if (findObj !== undefined) {
                seqKeys.push(row[0][item])
                countCheck++
              } else {
                keyErrors.push(row[0][item])
              }
            })

            if (
              (vm.userInfo.user_type == 'Vendor' && haveBussiness) ||
              (vm.userInfo.user_type == 'Operator' && !haveBussiness) ||
              (vm.vendorComponentModel.model.vendor_type === 'OFMStock' &&
                !haveDiscountRate) ||
              (vm.vendorComponentModel.model.vendor_type === 'DropShip' &&
                haveDiscountRate)
            ) {
              isValidateFormat = true
            }

            console.log(
              countCheck +
                ' --- ' +
                vm.excel.header_excel_ofm_stock_operator.length
            )
            console.log(countCheck + ' keyErrors --- ' + keyErrors)
          }
        })
        console.log(
          '🚀 ~ file: import-excel.vue:3346 ~ workbook.SheetNames.forEach ~ workbook:',
          workbook
        )
        console.log(
          '🚀 ~ file: import-excel.vue:3346 ~ workbook.SheetNames.forEach ~ workbook.SheetNames:',
          workbook.SheetNames
        )

        if (isValidateFormat) {
          vm.$utils.notification('info', 'Format File Excel ผิดรูปแบบ')
          vm.onClear()
          return
        }

        if (isEmtryData) {
          vm.$utils.notification('info', 'ไม่พบข้อมูลใน Excel')
          vm.onClear()
          return
        }

        workbook.SheetNames.forEach(function(sheetName) {
          var row = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[sheetName]
          )

          let itemRows = []
          for (let i = 0; i < row.length; i++) {
            itemRows.push(row[i])
          }
          let propertyExcel = []
          for (var property in itemRows[0]) {
            propertyExcel.push(property)
          }

          if (sheetName === 'Template' || sheetName === 'Data') {
            var itemRowsData = []

            let propertyAttribute = propertyExcel.filter(
              x => headExcel.indexOf(x) === -1
            )
            for (var r in propertyAttribute) {
              if (row[2][propertyAttribute[r]] == 'Optional') {
                vm.isMandatory = 'false'
              }
            }

            for (let i = 3; i < row.length; i++) {
              itemRowsData.push(row[i])
            }
            vm.itemImportTmp = itemRowsData

            let duplicates = []
            let uniqueItems = []
            itemRowsData.forEach(item => {
              if (uniqueItems.includes(item.sku_code_vendor)) {
                if (!duplicates.includes(item)) {
                  duplicates.push(item)
                }
              } else {
                uniqueItems.push(item.sku_code_vendor)
              }
            })
            if (duplicates.length > 0) {

              vm.$utils.notification('info', `มี รหัสสินค้าของผู้ขาย ที่ซ้ำกัน`)
              vm.onClear()
              return
            }
      
            var dataTask = []
            // var dataExcelGroupBy = vm.groupByData(itemRowsData,"group_id")
            //Split data for map RI with same brand_name,series_name_en,category_name,group_id
            var dataExcelGroupBy = vm.splitByData(itemRowsData)
            vm.$bvModal.show('modal-option-excel')
            for (var i = 0; i < dataExcelGroupBy.length; i++) {
              let key = dataExcelGroupBy[i].key
              let group_id = dataExcelGroupBy[i].values[0].group_id
              let dataPlayload = vm.mappingDataValidateExcel(
                dataExcelGroupBy[i].values
              )
              let temp = {
                index: i + 1,
                key: key,
                group_id: group_id,
                product_name_th: dataPlayload[0].product_name.display_name.th,
                product_name_en: dataPlayload[0].product_name.display_name.en,
                status: 'loading',
                action: '',
                temp: '',
                response: '',
                temp_data_import: dataExcelGroupBy[i],
              }
              vm.dataTempExcel.push(temp)

              let task1 = () => {
                return new Promise(async (resolve, reject) => {
                  var result = await vm.validateImportDataExcel2(dataPlayload)
                  resolve({
                    id: key,
                    group_id: group_id,
                    response: result,
                    playload: dataPlayload,
                  })
                })
              }
              dataTask.push(task1())
            }
            console.log('456')
            Promise.all(dataTask)
              .then(results => {
                console.log('results ', results) // ['Task 1 completed', 'Task 2 completed']
                if (results && results.length > 0) {
                  let isSuccess = true
                  for (var i = 0; i < results.length; i++) {
                    let data = vm.dataTempExcel.find(
                      w => w.key == results[i].id
                    )
                    let temp_data_import = []
                    if (data && data != undefined) {
                      data.status = results[i].response.status
                      data.temp = results[i]
                      data.response = results[i].response
                      temp_data_import = data.temp_data_import
                    }
                    if (results[i].response.status != 201) {
                      isSuccess = false
                    } else if (results[i].response.status == 201) {
                      if (
                        results[i].response.data &&
                        results[i].response.data != undefined
                      ) {
                        let dataPlayload_0 = results[i].playload[0]
                        let data_explain = []
                        for (
                          var ii = 0;
                          ii < results[i].response.data.length;
                          ii++
                        ) {
                          let dataPlatload = results[i].playload[ii]
                          let mechanics_th = ''
                          let mechanics_en = ''
                          if (
                            dataPlatload.sku_mechanics &&
                            dataPlatload.sku_mechanics.length > 0
                          ) {
                            dataPlatload.sku_mechanics.forEach(mac => {
                              if (mac.value.display_name) {
                                mechanics_th =
                                  mechanics_th +
                                  ' ' +
                                  mac.value.display_name.th +
                                  ' '
                                mechanics_en =
                                  mechanics_en +
                                  ' ' +
                                  mac.value.display_name.en +
                                  ' '
                              }
                            })
                          }

                          let temp_explain = {
                            index: ii + 1,
                            sku: '',
                            product_name_th:
                              dataPlatload.product_name.display_name.th +
                              mechanics_th,
                            product_name_en:
                              dataPlatload.product_name.display_name.en +
                              mechanics_en,
                            remark: results[i].response.data[ii].message,
                            action: '',
                          }
                          data_explain.push(temp_explain)
                        }

                        let tempItem = {
                          key: results[i].id,
                          index: i + 1,
                          group_id: data.group_id,
                          product_name_th:
                            dataPlayload_0.product_name.display_name.th,
                          product_name_en:
                            dataPlayload_0.product_name.display_name.en,
                          brand_th: dataPlayload_0.brand_name.display_name.th,
                          brand_en: dataPlayload_0.brand_name.display_name.en,
                          series_th: dataPlayload_0.series_name.display_name.th,
                          series_en: dataPlayload_0.series_name.display_name.en,
                          sku_count: results[i].playload.length,
                          data_explain: data_explain,
                          data_temp: results[i].playload,
                          temp_data_import: temp_data_import,
                        }
                        if (
                          results[i].response.data.some(
                            w => w.message != null && w.message.length > 0
                          )
                        ) {
                          //TODOO Failed
                          vm.itemFailed.push(tempItem)
                        } else {
                          //TODOO Success
                          vm.itemSuccess.push(tempItem)
                        }
                      }
                    }
                  }
                  console.log('itemSuccess ', vm.itemSuccess)
                  if (isSuccess) {
                    vm.$bvModal.hide('modal-option-excel')
                    vm.isLoadValidate = true
                  }
                }
              })
              .catch(error => {
                console.error(error)
              })
          } else {
            for (var p = 0; p < propertyExcel.length; p++) {
              let dataRef = itemRows.map(m => m[propertyExcel[p]])
              let tempRef = [propertyExcel[p]].concat(dataRef)
              vm.excel.head_data_validation[propertyExcel[p]] = tempRef.filter(
                w => w != undefined
              )
            }

            let attribute = []
            if (
              vm.excel.head_data_validation['attribute_set'] &&
              vm.excel.head_data_validation['attribute_set'].length > 0
            ) {
              vm.excel.head_data_validation['attribute_set'].forEach(item => {
                let checkAttribute = vm.attributeSetGroupProductSelectList.find(
                  w => w.value != undefined && w.value.th == item
                )
                if (checkAttribute && checkAttribute != undefined) {
                  if (
                    checkAttribute.attributes &&
                    checkAttribute.attributes.length > 0
                  ) {
                    checkAttribute.attributes
                      .filter(w => w.status == 'Active')
                      .forEach((at, index) => {
                        if (vm.isMandatory == 'true' && !at.is_required_value) {
                          return
                        }
                        attribute.push(at)
                      })
                  }
                }
              })
            }
            for (var ii = 0; ii < attribute.length; ii++) {
              if (
                !vm.attributeListDistinct.some(w => w.id == attribute[ii].id)
              ) {
                vm.attributeListDistinct.push(attribute[ii])
              }
            }
            console.log(
              'headerKeys head_data_validation',
              vm.excel.head_data_validation
            )
          }
        })
      }
      vm.validateImportSuccess = true
      reader.readAsBinaryString(selectedFile)
    },
    async onDownloadTemplate(flag) {
      let workbook = new Workbook()
      let worksheet = workbook.addWorksheet('Template')

      //// SET UP HEADER TEXT  AND STYLE ////
      var headerTexts = []
      var headerKeys = []
      var headoption = []
      var headMandatory = []
      var headExcel = []

      console.log(this.vendorComponentModel.model.vendor_type)

      worksheet.getRow(1).fill = this.excel.header_excel_style_background
      worksheet.getRow(2).fill = this.excel.header_excel_style_background2
      worksheet.getRow(3).fill = this.excel.header_excel_style_background3
      worksheet.getRow(4).fill = this.excel.header_excel_style_background4
      worksheet.getRow(1).font = this.excel.header_excel_style_font
      worksheet.getRow(2).font = this.excel.header_excel_style_font
      worksheet.getRow(3).font = this.excel.header_excel_style_font
      worksheet.getRow(4).font = this.excel.header_excel_style_font_mandatory
      if (this.vendorComponentModel.model.vendor_type === 'OFMStock') {
        if (
          this.userInfo.user_type === 'Vendor' &&
          this.GET_VENDOR_SELECTED &&
          (this.GET_VENDOR_SELECTED.type === 'OFMStock' ||
            this.GET_VENDOR_SELECTED.type === 'DropShip')
        ) {
          headExcel = this.excel.header_excel_ofm_stock_vendor
        } else {
          headExcel = this.excel.header_excel_ofm_stock_operator
        }
      } else {
        if (
          this.userInfo.user_type === 'Vendor' &&
          this.GET_VENDOR_SELECTED &&
          (this.GET_VENDOR_SELECTED.type === 'OFMStock' ||
            this.GET_VENDOR_SELECTED.type === 'DropShip')
        ) {
          headExcel = this.excel.header_excel_drop_ship_vendor
        } else {
          headExcel = this.excel.header_excel_drop_ship_operator
        }
      }
      for (var i = 0; i < headExcel.length; i++) {
        if (headExcel[i].key == 'attribute') {
          if (
            this.attributeListDistinct &&
            this.attributeListDistinct.length > 0
          ) {
            this.attributeListDistinct.forEach(item => {
              var mendatory = 'Optional'
              if (item.is_required_value) {
                mendatory = 'Mandatory'
              }
              headerTexts.push(item.display_name.th)
              headerKeys.push(item.id)
              headoption.push('')
              headMandatory.push(mendatory)
            })
          }
        } else {
          // if(this.isMandatory == "true" && headExcel[i].Mandatory != "Mandatory"){
          //   continue;
          // }
          headerTexts.push(headExcel[i].value)
          headerKeys.push(headExcel[i].key)
          headoption.push(headExcel[i].option)
          headMandatory.push(headExcel[i].Mandatory)
        }
      }

      headerKeys.push('remark')
      worksheet.getRow(1).values = headerKeys
      worksheet.getRow(2).values = headerTexts
      worksheet.getRow(3).values = headoption
      worksheet.getRow(4).values = headMandatory

      worksheet.columns.forEach((column, index) => {
        var maxWidth = 0
        for (var i = 1; i <= 4; i++) {
          const num = column.values[i]
          if (num != undefined) {
            if (maxWidth <= column.values[i].length) {
              maxWidth = column.values[i].length
            }
          }
        }
        column.width = maxWidth + 10
      })

      let dataTemp = []
      if (flag == 'darft') {
        //dataTemp = this.dataTempExcelDarft.filter(w=>w.status != '201')
        dataTemp = this.itemFailed
      } else {
        dataTemp = this.dataTempExcelRI.filter(w => w.status != '201')
      }
      console.log('headerKeys', headerKeys)
      if (dataTemp && dataTemp.length > 0) {
        let index = 1
        dataTemp.forEach((data, dataTemp_index) => {
          if (
            data.temp_data_import.values &&
            data.temp_data_import.values.length > 0
          ) {
            data.temp_data_import.values.forEach(temp => {
              //
              //console.log("headerKeys temp",temp)

              let dataExport = []
              let data_remark = []
              if (data.data_explain && data.data_explain.length > 0) {
                data.data_explain.forEach(item => {
                  if (item.remark && item.remark.length > 0) {
                    for (var ii = 0; ii < item.remark.length; ii++) {
                      data_remark.push(item.remark[ii])
                    }
                  }
                })
              }
              for (var i = 0; i <= headerKeys.length; i++) {
                let dt = temp[headerKeys[i]]
                //console.log("headerKeys data",dt)
                if (headerKeys[i] == 'remark') {
                  dataExport.push(data_remark.join('\n'))
                  continue
                }
                if (dt != undefined) {
                  dataExport.push(dt)
                } else {
                  dataExport.push('')
                }
              }

              worksheet.getRow(4 + index).values = dataExport
              index++
            })
          }
        })
      }

      worksheet.columns.forEach((c, rowNumber) => {
        c.numFmt = '@'
      })

      if (this.vendorComponentModel.model.vendor_type === 'OFMStock') {
        if (
          this.userInfo.user_type === 'Vendor' &&
          this.GET_VENDOR_SELECTED &&
          (this.GET_VENDOR_SELECTED.type === 'OFMStock' ||
            this.GET_VENDOR_SELECTED.type === 'DropShip')
        ) {
          //TODOO Ofm Stock Vendor
          worksheet.dataValidations.add('A5:A9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$A$2:$A$${this.excel.head_data_validation.category_name.length}`,
            ],
          })

          worksheet.dataValidations.add('B5:B9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$B$2:$B$${this.excel.head_data_validation.brand_name.length}`,
            ],
          })

          worksheet.dataValidations.add('H5:H9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$C$2:$C$${this.excel.head_data_validation.unit.length}`,
            ],
          })

          worksheet.dataValidations.add('I5:I9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$D$2:$D$${this.excel.head_data_validation.mechanic.length}`,
            ],
          })
          worksheet.dataValidations.add('K5:K9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$D$2:$D$${this.excel.head_data_validation.mechanic.length}`,
            ],
          })
          worksheet.dataValidations.add('M5:M9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$D$2:$D$${this.excel.head_data_validation.mechanic.length}`,
            ],
          })

          worksheet.dataValidations.add('AR5:AR9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$H$2:$H$${this.excel.head_data_validation.attribute_set.length}`,
            ],
          })

          worksheet.dataValidations.add('Q5:Q9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$I$2:$I$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('AN5:AN9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$I$2:$I$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('AP5:AP9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$I$2:$I$${this.excel.head_data_validation.flag.length}`,
            ],
          })

          worksheet.dataValidations.add('AO5:AO9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$J$2:$J$${this.excel.head_data_validation.aging.length}`,
            ],
          })

          worksheet.dataValidations.add('J5:J9999', {
            type: 'list',
            formulae: [
              `=IF(INDEX($I$1:$I$9999,ROW(),1)="สี : Color",ReferenceData!$E$2:$E$${this.excel.head_data_validation.color.length},IF(INDEX($I$1:$I$9999,ROW(),1)="ชนิดของวัสดุ : Body Material",ReferenceData!$F$2:$F$${this.excel.head_data_validation.material.length},IF(INDEX($I$1:$I$9999,ROW(),1)="ความจุ : Capacity (GB.)",ReferenceData!$G$2:$G$${this.excel.head_data_validation.capacity_gb.length},"")))`,
            ],
          })
          worksheet.dataValidations.add('L5:L9999', {
            type: 'list',
            formulae: [
              `=IF(INDEX($K$1:$K$9999,ROW(),1)="สี : Color",ReferenceData!$E$2:$E$${this.excel.head_data_validation.color.length},IF(INDEX($K$1:$K$9999,ROW(),1)="ชนิดของวัสดุ : Body Material",ReferenceData!$F$2:$F$${this.excel.head_data_validation.material.length},IF(INDEX($K$1:$K$9999,ROW(),1)="ความจุ : Capacity (GB.)",ReferenceData!$G$2:$G$${this.excel.head_data_validation.capacity_gb.length},"")))`,
            ],
          })
          worksheet.dataValidations.add('N5:N9999', {
            type: 'list',
            formulae: [
              `=IF(INDEX($M$1:$M$9999,ROW(),1)="สี : Color",ReferenceData!$E$2:$E$${this.excel.head_data_validation.color.length},IF(INDEX($M$1:$M$9999,ROW(),1)="ชนิดของวัสดุ : Body Material",ReferenceData!$F$2:$F$${this.excel.head_data_validation.material.length},IF(INDEX($M$1:$M$9999,ROW(),1)="ความจุ : Capacity (GB.)",ReferenceData!$G$2:$G$${this.excel.head_data_validation.capacity_gb.length},"")))`,
            ],
          })

          let indexRef = 1
          for (let i = 0; i < this.attributeListDistinct.length; i++) {
            let fieldName = ''
            // if(this.isMandatory == "true"){
            //   fieldName = this.num_hash((i + 1) + 22);
            // }else{
            //   fieldName = this.num_hash((i + 1) + 44);
            // }
            fieldName = this.num_hash(i + 1 + 44)

            if (
              this.attributeListDistinct[i].type == 'Multiple Select' ||
              this.attributeListDistinct[i].type == 'Dropdown'
            ) {
              let fieldRef = this.num_hash(indexRef + 10)
              worksheet.dataValidations.add(
                fieldName + '5:' + fieldName + '9999',
                {
                  type: 'list',
                  formulae: [
                    '=ReferenceData!$' +
                      fieldRef +
                      '$2:$' +
                      fieldRef +
                      '$' +
                      (this.attributeListDistinct[i].data_values.length + 1),
                  ],
                }
              )
              indexRef++
            } else if (this.attributeListDistinct[i].type == 'Boolean') {
              worksheet.dataValidations.add(
                fieldName + '5:' + fieldName + '9999',
                {
                  type: 'list',
                  formulae: [
                    `=ReferenceData!$I$2:$I$${this.excel.head_data_validation.flag.length}`,
                  ],
                }
              )
            }
          }

          worksheet = workbook.addWorksheet('ReferenceData')
          worksheet.getColumn(
            1
          ).values = this.excel.head_data_validation.category_name
          worksheet.getColumn(
            2
          ).values = this.excel.head_data_validation.brand_name
          worksheet.getColumn(3).values = this.excel.head_data_validation.unit
          worksheet.getColumn(
            4
          ).values = this.excel.head_data_validation.mechanic
          worksheet.getColumn(5).values = this.excel.head_data_validation.color
          worksheet.getColumn(
            6
          ).values = this.excel.head_data_validation.material
          worksheet.getColumn(
            7
          ).values = this.excel.head_data_validation.capacity_gb
          worksheet.getColumn(
            8
          ).values = this.excel.head_data_validation.attribute_set
          worksheet.getColumn(9).values = this.excel.head_data_validation.flag
          worksheet.getColumn(10).values = this.excel.head_data_validation.aging
          worksheet.getRow(1).fill = this.excel.header_excel_style_background
          worksheet.getRow(1).font = this.excel.header_excel_style_font

          this.attributeListDistinct
            .filter(w => w.type == 'Multiple Select' || w.type == 'Dropdown')
            .forEach((item, index) => {
              let head_data_attribute = [item.id]
              item.data_values.forEach(s => {
                let dataAttribute = s.value.th + ' : ' + s.value.en
                head_data_attribute.push(dataAttribute)
              })
              worksheet.getColumn(10 + (index + 1)).values = head_data_attribute
            })

          worksheet.columns.forEach((column, index) => {
            var maxWidth = 0
            for (var i = 1; i <= 4; i++) {
              const num = column.values[i]
              if (num != undefined) {
                if (maxWidth <= column.values[i].length) {
                  maxWidth = column.values[i].length
                }
              }
            }
            column.width = maxWidth + 10
          })
        } else {
          //TODOO Ofm Stock Operator
          worksheet.dataValidations.add('B5:B9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$A$2:$A$${this.excel.head_data_validation.category_name.length}`,
            ],
          })

          worksheet.dataValidations.add('C5:C9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$B$2:$B$${this.excel.head_data_validation.brand_name.length}`,
            ],
          })

          worksheet.dataValidations.add('I5:I9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$C$2:$C$${this.excel.head_data_validation.unit.length}`,
            ],
          })

          worksheet.dataValidations.add('J5:J9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$D$2:$D$${this.excel.head_data_validation.mechanic.length}`,
            ],
          })
          worksheet.dataValidations.add('L5:L9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$D$2:$D$${this.excel.head_data_validation.mechanic.length}`,
            ],
          })
          worksheet.dataValidations.add('N5:N9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$D$2:$D$${this.excel.head_data_validation.mechanic.length}`,
            ],
          })

          worksheet.dataValidations.add('BQ5:BQ9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$O$2:$O$${this.excel.head_data_validation.attribute_set.length}`,
            ],
          })

          worksheet.dataValidations.add('BC5:BC9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$M$2:$M$${this.excel.head_data_validation.warehouse.length}`,
            ],
          })
          worksheet.dataValidations.add('BD5:BD9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$N$2:$N$${this.excel.head_data_validation.sub_warehouse.length}`,
            ],
          })

          worksheet.dataValidations.add('V5:V9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$H$2:$H$${this.excel.head_data_validation.fix_price_period.length}`,
            ],
          })

          worksheet.dataValidations.add('AE5:AE9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$I$2:$I$${this.excel.head_data_validation.product_status_inventory.length}`,
            ],
          })

          worksheet.dataValidations.add('AF5:AF9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$J$2:$J$${this.excel.head_data_validation.jda_status.length}`,
            ],
          })

          worksheet.dataValidations.add('AG5:AG9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$K$2:$K$${this.excel.head_data_validation.jda_special_type.length}`,
            ],
          })

          worksheet.dataValidations.add('AV5:AV9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$L$2:$L$${this.excel.head_data_validation.delivery_lead_time.length}`,
            ],
          })

          worksheet.dataValidations.add('U5:U9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$P$2:$P$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('AA5:AA9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$P$2:$P$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('BB5:BB9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$P$2:$P$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('BE5:BE9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$P$2:$P$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('BF5:BF9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$P$2:$P$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('BI5:BI9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$P$2:$P$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('BJ5:BJ9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$P$2:$P$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('BK5:BK9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$P$2:$P$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('BL5:BL9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$P$2:$P$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('BM5:BM9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$P$2:$P$${this.excel.head_data_validation.flag.length}`,
            ],
          })

          worksheet.dataValidations.add('BG5:BG9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$Q$2:$Q$${this.excel.head_data_validation.aging.length}`,
            ],
          })

          worksheet.dataValidations.add('BH5:BH9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$R$2:$R$${
                this.excel.head_data_validation.type
                  ? this.excel.head_data_validation.type.length
                  : '9999'
              }`,
            ],
          })

          worksheet.dataValidations.add('K5:K9999', {
            type: 'list',
            formulae: [
              `=IF(INDEX($J$1:$J$9999,ROW(),1)="สี : Color",ReferenceData!$E$2:$E$${this.excel.head_data_validation.color.length},IF(INDEX($J$1:$J$9999,ROW(),1)="ชนิดของวัสดุ : Body Material",ReferenceData!$F$2:$F$${this.excel.head_data_validation.material.length},IF(INDEX($J$1:$J$9999,ROW(),1)="ความจุ : Capacity (GB.)",ReferenceData!$G$2:$G$${this.excel.head_data_validation.capacity_gb.length},"")))`,
            ],
          })
          worksheet.dataValidations.add('M5:M9999', {
            type: 'list',
            formulae: [
              `=IF(INDEX($L$1:$L$9999,ROW(),1)="สี : Color",ReferenceData!$E$2:$E$${this.excel.head_data_validation.color.length},IF(INDEX($L$1:$L$9999,ROW(),1)="ชนิดของวัสดุ : Body Material",ReferenceData!$F$2:$F$${this.excel.head_data_validation.material.length},IF(INDEX($L$1:$L$9999,ROW(),1)="ความจุ : Capacity (GB.)",ReferenceData!$G$2:$G$${this.excel.head_data_validation.capacity_gb.length},"")))`,
            ],
          })
          worksheet.dataValidations.add('O5:O9999', {
            type: 'list',
            formulae: [
              `=IF(INDEX($N$1:$N$9999,ROW(),1)="สี : Color",ReferenceData!$E$2:$E$${this.excel.head_data_validation.color.length},IF(INDEX($N$1:$N$9999,ROW(),1)="ชนิดของวัสดุ : Body Material",ReferenceData!$F$2:$F$${this.excel.head_data_validation.material.length},IF(INDEX($N$1:$N$9999,ROW(),1)="ความจุ : Capacity (GB.)",ReferenceData!$G$2:$G$${this.excel.head_data_validation.capacity_gb.length},"")))`,
            ],
          })

          let indexRef = 1
          for (let i = 0; i < this.attributeListDistinct.length; i++) {
            let fieldName = ''
            // if(this.isMandatory == "true"){
            //   fieldName = this.num_hash((i + 1) + 35);
            // }else{
            //   fieldName = this.num_hash((i + 1) + 68);
            // }
            fieldName = this.num_hash(i + 1 + 69)

            if (
              this.attributeListDistinct[i].type == 'Multiple Select' ||
              this.attributeListDistinct[i].type == 'Dropdown'
            ) {
              let fieldRef = this.num_hash(indexRef + 18)
              worksheet.dataValidations.add(
                fieldName + '5:' + fieldName + '9999',
                {
                  type: 'list',
                  formulae: [
                    '=ReferenceData!$' +
                      fieldRef +
                      '$2:$' +
                      fieldRef +
                      '$' +
                      (this.attributeListDistinct[i].data_values.length + 1),
                  ],
                }
              )
              indexRef++
            } else if (this.attributeListDistinct[i].type == 'Boolean') {
              worksheet.dataValidations.add(
                fieldName + '5:' + fieldName + '9999',
                {
                  type: 'list',
                  formulae: [
                    `=ReferenceData!$P$2:$P$${this.excel.head_data_validation.flag.length}`,
                  ],
                }
              )
            }
          }

          worksheet = workbook.addWorksheet('ReferenceData')
          worksheet.getColumn(
            1
          ).values = this.excel.head_data_validation.category_name
          worksheet.getColumn(
            2
          ).values = this.excel.head_data_validation.brand_name
          worksheet.getColumn(3).values = this.excel.head_data_validation.unit
          worksheet.getColumn(
            4
          ).values = this.excel.head_data_validation.mechanic
          worksheet.getColumn(5).values = this.excel.head_data_validation.color
          worksheet.getColumn(
            6
          ).values = this.excel.head_data_validation.material
          worksheet.getColumn(
            7
          ).values = this.excel.head_data_validation.capacity_gb
          worksheet.getColumn(
            8
          ).values = this.excel.head_data_validation.fix_price_period
          worksheet.getColumn(
            9
          ).values = this.excel.head_data_validation.product_status_inventory
          worksheet.getColumn(
            10
          ).values = this.excel.head_data_validation.jda_status
          worksheet.getColumn(
            11
          ).values = this.excel.head_data_validation.jda_special_type
          worksheet.getColumn(
            12
          ).values = this.excel.head_data_validation.delivery_lead_time
          worksheet.getColumn(
            13
          ).values = this.excel.head_data_validation.warehouse
          worksheet.getColumn(
            14
          ).values = this.excel.head_data_validation.sub_warehouse
          worksheet.getColumn(
            15
          ).values = this.excel.head_data_validation.attribute_set
          worksheet.getColumn(16).values = this.excel.head_data_validation.flag
          worksheet.getColumn(17).values = this.excel.head_data_validation.aging
          worksheet.getColumn(18).values = this.excel.head_data_validation.type
          worksheet.getRow(1).fill = this.excel.header_excel_style_background
          worksheet.getRow(1).font = this.excel.header_excel_style_font

          this.attributeListDistinct
            .filter(w => w.type == 'Multiple Select' || w.type == 'Dropdown')
            .forEach((item, index) => {
              let head_data_attribute = [item.id]
              item.data_values.forEach(s => {
                let dataAttribute = s.value.th + ' : ' + s.value.en
                head_data_attribute.push(dataAttribute)
              })
              worksheet.getColumn(18 + (index + 1)).values = head_data_attribute
            })

          worksheet.columns.forEach((column, index) => {
            var maxWidth = 0
            for (var i = 1; i <= 4; i++) {
              const num = column.values[i]
              if (num != undefined) {
                if (maxWidth <= column.values[i].length) {
                  maxWidth = column.values[i].length
                }
              }
            }
            column.width = maxWidth + 10
          })
        }
      } else {
        if (
          this.userInfo.user_type === 'Vendor' &&
          this.GET_VENDOR_SELECTED &&
          (this.GET_VENDOR_SELECTED.type === 'OFMStock' ||
            this.GET_VENDOR_SELECTED.type === 'DropShip')
        ) {
          //TODOO Drop Ship Vendor
          worksheet.dataValidations.add('A5:A9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$A$2:$A$${this.excel.head_data_validation.category_name.length}`,
            ],
          })

          worksheet.dataValidations.add('B5:B9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$B$2:$B$${this.excel.head_data_validation.brand_name.length}`,
            ],
          })

          worksheet.dataValidations.add('H5:H9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$C$2:$C$${this.excel.head_data_validation.unit.length}`,
            ],
          })

          worksheet.dataValidations.add('I5:I9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$D$2:$D$${this.excel.head_data_validation.mechanic.length}`,
            ],
          })
          worksheet.dataValidations.add('K5:K9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$D$2:$D$${this.excel.head_data_validation.mechanic.length}`,
            ],
          })
          worksheet.dataValidations.add('M5:M9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$D$2:$D$${this.excel.head_data_validation.mechanic.length}`,
            ],
          })

          worksheet.dataValidations.add('AJ5:AJ9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$H$2:$H$${this.excel.head_data_validation.delivery_lead_time.length}`,
            ],
          })

          worksheet.dataValidations.add('Q5:Q9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$J$2:$J$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('AO5:AO9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$J$2:$J$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('AQ5:AQ9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$J$2:$J$${this.excel.head_data_validation.flag.length}`,
            ],
          })

          worksheet.dataValidations.add('AS5:AS9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$I$2:$I$${this.excel.head_data_validation.attribute_set.length}`,
            ],
          })

          worksheet.dataValidations.add('AP5:AP9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$K$2:$K$${this.excel.head_data_validation.aging.length}`,
            ],
          })

          worksheet.dataValidations.add('J5:J9999', {
            type: 'list',
            formulae: [
              `=IF(INDEX($I$1:$I$9999,ROW(),1)="สี : Color",ReferenceData!$E$2:$E$${this.excel.head_data_validation.color.length},IF(INDEX($I$1:$I$9999,ROW(),1)="ชนิดของวัสดุ : Body Material",ReferenceData!$F$2:$F$${this.excel.head_data_validation.material.length},IF(INDEX($I$1:$I$9999,ROW(),1)="ความจุ : Capacity (GB.)",ReferenceData!$G$2:$G$${this.excel.head_data_validation.capacity_gb.length},"")))`,
            ],
          })
          worksheet.dataValidations.add('L5:L9999', {
            type: 'list',
            formulae: [
              `=IF(INDEX($K$1:$K$9999,ROW(),1)="สี : Color",ReferenceData!$E$2:$E$${this.excel.head_data_validation.color.length},IF(INDEX($K$1:$K$9999,ROW(),1)="ชนิดของวัสดุ : Body Material",ReferenceData!$F$2:$F$${this.excel.head_data_validation.material.length},IF(INDEX($K$1:$K$9999,ROW(),1)="ความจุ : Capacity (GB.)",ReferenceData!$G$2:$G$${this.excel.head_data_validation.capacity_gb.length},"")))`,
            ],
          })
          worksheet.dataValidations.add('N5:N9999', {
            type: 'list',
            formulae: [
              `=IF(INDEX($M$1:$M$9999,ROW(),1)="สี : Color",ReferenceData!$E$2:$E$${this.excel.head_data_validation.color.length},IF(INDEX($M$1:$M$9999,ROW(),1)="ชนิดของวัสดุ : Body Material",ReferenceData!$F$2:$F$${this.excel.head_data_validation.material.length},IF(INDEX($M$1:$M$9999,ROW(),1)="ความจุ : Capacity (GB.)",ReferenceData!$G$2:$G$${this.excel.head_data_validation.capacity_gb.length},"")))`,
            ],
          })

          let indexRef = 1
          for (let i = 0; i < this.attributeListDistinct.length; i++) {
            let fieldName = ''
            // if(this.isMandatory == "true"){
            //   fieldName = this.num_hash((i + 1) + 21);
            // }else{
            //   fieldName = this.num_hash((i + 1) + 45);
            // }
            fieldName = this.num_hash(i + 1 + 45)

            if (
              this.attributeListDistinct[i].type == 'Multiple Select' ||
              this.attributeListDistinct[i].type == 'Dropdown'
            ) {
              let fieldRef = this.num_hash(indexRef + 11)
              worksheet.dataValidations.add(
                fieldName + '5:' + fieldName + '9999',
                {
                  type: 'list',
                  formulae: [
                    '=ReferenceData!$' +
                      fieldRef +
                      '$2:$' +
                      fieldRef +
                      '$' +
                      (this.attributeListDistinct[i].data_values.length + 1),
                  ],
                }
              )
              indexRef++
            } else if (this.attributeListDistinct[i].type == 'Boolean') {
              worksheet.dataValidations.add(
                fieldName + '5:' + fieldName + '9999',
                {
                  type: 'list',
                  formulae: [
                    `=ReferenceData!$J$2:$J$${this.excel.head_data_validation.flag.length}`,
                  ],
                }
              )
            }
          }

          worksheet = workbook.addWorksheet('ReferenceData')
          worksheet.getColumn(
            1
          ).values = this.excel.head_data_validation.category_name
          worksheet.getColumn(
            2
          ).values = this.excel.head_data_validation.brand_name
          worksheet.getColumn(3).values = this.excel.head_data_validation.unit
          worksheet.getColumn(
            4
          ).values = this.excel.head_data_validation.mechanic
          worksheet.getColumn(5).values = this.excel.head_data_validation.color
          worksheet.getColumn(
            6
          ).values = this.excel.head_data_validation.material
          worksheet.getColumn(
            7
          ).values = this.excel.head_data_validation.capacity_gb
          worksheet.getColumn(
            8
          ).values = this.excel.head_data_validation.delivery_lead_time
          worksheet.getColumn(
            9
          ).values = this.excel.head_data_validation.attribute_set
          worksheet.getColumn(10).values = this.excel.head_data_validation.flag
          worksheet.getColumn(11).values = this.excel.head_data_validation.aging
          worksheet.getRow(1).fill = this.excel.header_excel_style_background
          worksheet.getRow(1).font = this.excel.header_excel_style_font

          this.attributeListDistinct
            .filter(w => w.type == 'Multiple Select' || w.type == 'Dropdown')
            .forEach((item, index) => {
              let head_data_attribute = [item.id]
              item.data_values.forEach(s => {
                let dataAttribute = s.value.th + ' : ' + s.value.en
                head_data_attribute.push(dataAttribute)
              })
              worksheet.getColumn(11 + (index + 1)).values = head_data_attribute
            })

          worksheet.columns.forEach((column, index) => {
            var maxWidth = 0
            for (var i = 1; i <= 4; i++) {
              const num = column.values[i]
              if (num != undefined) {
                if (maxWidth <= column.values[i].length) {
                  maxWidth = column.values[i].length
                }
              }
            }
            column.width = maxWidth + 10
          })
        } else {
          //TODOO Drop Ship Operator
          worksheet.dataValidations.add('B5:B9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$A$2:$A$${this.excel.head_data_validation.category_name.length}`,
            ],
          })

          worksheet.dataValidations.add('C5:C9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$B$2:$B$${this.excel.head_data_validation.brand_name.length}`,
            ],
          })

          worksheet.dataValidations.add('I5:I9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$C$2:$C$${this.excel.head_data_validation.unit.length}`,
            ],
          })

          worksheet.dataValidations.add('J5:J9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$D$2:$D$${this.excel.head_data_validation.mechanic.length}`,
            ],
          })
          worksheet.dataValidations.add('L5:L9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$D$2:$D$${this.excel.head_data_validation.mechanic.length}`,
            ],
          })
          worksheet.dataValidations.add('N5:N9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$D$2:$D$${this.excel.head_data_validation.mechanic.length}`,
            ],
          })

          worksheet.dataValidations.add('Z5:Z9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$H$2:$H$${this.excel.head_data_validation.product_status_inventory.length}`,
            ],
          })

          worksheet.dataValidations.add('AO5:AO9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$I$2:$I$${this.excel.head_data_validation.delivery_lead_time.length}`,
            ],
          })

          worksheet.dataValidations.add('T5:T9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$K$2:$K$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('W5:W9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$K$2:$K$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('AT5:AT9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$K$2:$K$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('AV5:AV9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$K$2:$K$${this.excel.head_data_validation.flag.length}`,
            ],
          })
          worksheet.dataValidations.add('AW5:AW9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$K$2:$K$${this.excel.head_data_validation.flag.length}`,
            ],
          })

          worksheet.dataValidations.add('AY5:AY9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$J$2:$J$${this.excel.head_data_validation.attribute_set.length}`,
            ],
          })

          worksheet.dataValidations.add('AU5:AU9999', {
            type: 'list',
            formulae: [
              `=ReferenceData!$L$2:$L$${this.excel.head_data_validation.aging.length}`,
            ],
          })

          worksheet.dataValidations.add('K5:K9999', {
            type: 'list',
            formulae: [
              `=IF(INDEX($J$1:$J$9999,ROW(),1)="สี : Color",ReferenceData!$E$2:$E$${this.excel.head_data_validation.color.length},IF(INDEX($J$1:$J$9999,ROW(),1)="ชนิดของวัสดุ : Body Material",ReferenceData!$F$2:$F$${this.excel.head_data_validation.material.length},IF(INDEX($J$1:$J$9999,ROW(),1)="ความจุ : Capacity (GB.)",ReferenceData!$G$2:$G$${this.excel.head_data_validation.capacity_gb.length},"")))`,
            ],
          })
          worksheet.dataValidations.add('M5:M9999', {
            type: 'list',
            formulae: [
              `=IF(INDEX($L$1:$L$9999,ROW(),1)="สี : Color",ReferenceData!$E$2:$E$${this.excel.head_data_validation.color.length},IF(INDEX($L$1:$L$9999,ROW(),1)="ชนิดของวัสดุ : Body Material",ReferenceData!$F$2:$F$${this.excel.head_data_validation.material.length},IF(INDEX($L$1:$L$9999,ROW(),1)="ความจุ : Capacity (GB.)",ReferenceData!$G$2:$G$${this.excel.head_data_validation.capacity_gb.length},"")))`,
            ],
          })
          worksheet.dataValidations.add('O5:O9999', {
            type: 'list',
            formulae: [
              `=IF(INDEX($N$1:$N$9999,ROW(),1)="สี : Color",ReferenceData!$E$2:$E$${this.excel.head_data_validation.color.length},IF(INDEX($N$1:$N$9999,ROW(),1)="ชนิดของวัสดุ : Body Material",ReferenceData!$F$2:$F$${this.excel.head_data_validation.material.length},IF(INDEX($N$1:$N$9999,ROW(),1)="ความจุ : Capacity (GB.)",ReferenceData!$G$2:$G$${this.excel.head_data_validation.capacity_gb.length},"")))`,
            ],
          })

          let indexRef = 1
          for (let i = 0; i < this.attributeListDistinct.length; i++) {
            let fieldName = ''
            // if(this.isMandatory == "true"){
            //   fieldName = this.num_hash((i + 1) + 24);
            // }else{
            //   fieldName = this.num_hash((i + 1) + 50);
            // }
            fieldName = this.num_hash(i + 1 + 51)

            if (
              this.attributeListDistinct[i].type == 'Multiple Select' ||
              this.attributeListDistinct[i].type == 'Dropdown'
            ) {
              let fieldRef = this.num_hash(indexRef + 12)
              worksheet.dataValidations.add(
                fieldName + '5:' + fieldName + '9999',
                {
                  type: 'list',
                  formulae: [
                    '=ReferenceData!$' +
                      fieldRef +
                      '$2:$' +
                      fieldRef +
                      '$' +
                      (this.attributeListDistinct[i].data_values.length + 1),
                  ],
                }
              )
              indexRef++
            } else if (this.attributeListDistinct[i].type == 'Boolean') {
              worksheet.dataValidations.add(
                fieldName + '5:' + fieldName + '9999',
                {
                  type: 'list',
                  formulae: [
                    `=ReferenceData!$K$2:$K$${this.excel.head_data_validation.flag.length}`,
                  ],
                }
              )
            }
          }

          worksheet = workbook.addWorksheet('ReferenceData')
          worksheet.getRow(1).fill = this.excel.header_excel_style_background
          worksheet.getColumn(
            1
          ).values = this.excel.head_data_validation.category_name
          worksheet.getColumn(
            2
          ).values = this.excel.head_data_validation.brand_name
          worksheet.getColumn(3).values = this.excel.head_data_validation.unit
          worksheet.getColumn(
            4
          ).values = this.excel.head_data_validation.mechanic
          worksheet.getColumn(5).values = this.excel.head_data_validation.color
          worksheet.getColumn(
            6
          ).values = this.excel.head_data_validation.material
          worksheet.getColumn(
            7
          ).values = this.excel.head_data_validation.capacity_gb
          worksheet.getColumn(
            8
          ).values = this.excel.head_data_validation.product_status_inventory
          worksheet.getColumn(
            9
          ).values = this.excel.head_data_validation.delivery_lead_time
          worksheet.getColumn(
            10
          ).values = this.excel.head_data_validation.attribute_set
          worksheet.getColumn(11).values = this.excel.head_data_validation.flag
          worksheet.getColumn(12).values = this.excel.head_data_validation.aging
          worksheet.getRow(1).fill = this.excel.header_excel_style_background
          worksheet.getRow(1).font = this.excel.header_excel_style_font

          this.attributeListDistinct
            .filter(w => w.type == 'Multiple Select' || w.type == 'Dropdown')
            .forEach((item, index) => {
              let head_data_attribute = [item.id]
              item.data_values.forEach(s => {
                let dataAttribute = s.value.th + ' : ' + s.value.en
                head_data_attribute.push(dataAttribute)
              })
              worksheet.getColumn(12 + (index + 1)).values = head_data_attribute
            })

          worksheet.columns.forEach((column, index) => {
            var maxWidth = 0
            for (var i = 1; i <= 4; i++) {
              const num = column.values[i]
              if (num != undefined) {
                if (maxWidth <= column.values[i].length) {
                  maxWidth = column.values[i].length
                }
              }
            }
            column.width = maxWidth + 10
          })
        }
      }
      //// SET UP REFERENCE DATA FIELD ////
      console.log('Export')
      workbook.xlsx.writeBuffer().then(data => {
        let blob = new Blob([data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        fs.saveAs(blob, ExportFileName(this.excel.template_file_name))
      })
    },
    num_hash(num) {
      if (num < 26) return this.alpha[num - 1]
      else {
        let q = Math.floor(num / 26),
          r = num % 26
        if (r == 0) {
          if (q == 1) return this.alpha[26 + r - 1]
          else return this.num_hash(q - 1) + this.alpha[26 + r - 1]
        } else return this.num_hash(q) + this.alpha[r - 1]
      }
    },
    groupByData(array, property) {
      return array.reduce((acc, obj) => {
        const key = obj[property]
        const group = acc.find(g => g.key === key)
        if (group) {
          group.values.push(obj)
        } else {
          acc.push({ key, values: [obj] })
        }
        return acc
      }, [])
    },
    splitByData(array) {
      let keys = ['brand_name', 'series_name_en', 'category_name', 'group_id']
      let _array = array
      _array.map(arr => {
        let localKey = ''
        keys.map(k => {
          if (arr['group_id'] == null) {
            localKey + '_' + uuidv4()
          }
          localKey = localKey + '_' + arr[k]
        })
        arr.localKey = localKey
      })

      let dataGroupBy = this.groupByData(_array, 'localKey')
      // dataGroupBy.forEach(element => {
      //   element.key = element.values[0].group_id
      // });

      console.log('dataGroupBy ', dataGroupBy)

      return dataGroupBy
    },
    onFindLastHybrid(items) {
      var lastData = this.hybridCategoryItems.find(
        w => w.view_name == items[0].trim()
      )
      if (lastData && lastData != undefined) {
        if (items.length == 1) {
          return lastData.view_id
        } else {
          for (var i = 1; i < items.length; i++) {
            var data = lastData.items.find(w => w.view_name == items[i].trim())
            if (data && data != undefined) {
              lastData = data
            }
          }
          return lastData.view_id
        }
      }
    },
    ExcelDateToJSDate(serial) {
      var utc_days = Math.floor(serial - 25569)
      var utc_value = utc_days * 86400
      var date_info = new Date(utc_value * 1000)

      var fractional_day = serial - Math.floor(serial) + 0.0000001

      var total_seconds = Math.floor(86400 * fractional_day)

      var seconds = total_seconds % 60

      total_seconds -= seconds

      var hours = Math.floor(total_seconds / (60 * 60))
      var minutes = Math.floor(total_seconds / 60) % 60

      return new Date(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds
      )
    },
    mappingDataValidateExcel(items) {
      let dataValidate = []
      if (items && items.length > 0) {
        items.forEach((data, index) => {
          let propertyExcel = []
          for (var property in data) {
            propertyExcel.push(property)
          }
          //console.log("propertyExcel",propertyExcel)
          let hybrid_category_id = ''
          let hybridSplite = data.category_name?.split('>')
          if (hybridSplite && hybridSplite.length > 0) {
            hybrid_category_id = this.onFindLastHybrid(hybridSplite)
          } else {
            hybrid_category_id = null
          }

          let brand_name =
            data.brand_name == undefined
              ? ''
              : data.brand_name.toString().trim()
          let tempBrand = this.brandDefault.find(
            w => w.display_name.th == brand_name
          )
          let branID = ''
          let brandName = ''
          if (tempBrand && tempBrand != undefined) {
            branID = tempBrand.id
            brandName = tempBrand.display_name
          }

          let unit_name =
            data.unit == undefined ? '' : data.unit.toString().trim()
          let tempUnit = this.unitDefault.find(
            w => w.display_name.th == unit_name
          )
          let unitID = ''
          let unitdName = { th: '', en: '' }
          if (tempUnit && tempUnit != undefined) {
            unitID = tempUnit.id
            unitdName = tempUnit.display_name
          }

          let sku_mechanics = []
          let mechanic_2 =
            data.mechanic_2 == undefined
              ? ''
              : data.mechanic_2.toString().trim()
          let mec2Value =
            data.mechanic_value_2 == undefined
              ? ''
              : data.mechanic_value_2.toString().trim()
          let mec2Split = mechanic_2.split(':')
          let mec2 = this.option_sku_mechanic_default.find(
            w => w.display_name.th == mec2Split[0].trim()
          )
          if (mec2 && mec2 != undefined) {
            let mec2ValueId = ''
            let mec2ValueDisplayName = {
              th: '',
              en: '',
            }
            if (mec2.option_values && mec2.option_values.length > 0) {
              let checkMec2Value = mec2.option_values.find(
                w => w.display_name.th == mec2Value
              )
              if (checkMec2Value && checkMec2Value != undefined) {
                mec2ValueId = checkMec2Value.id
                mec2ValueDisplayName = checkMec2Value.display_name
              }
            } else {
              mec2ValueDisplayName.th = mec2Value
              mec2ValueDisplayName.en = mec2Value
            }
            let tempMec2 = {
              id: mec2.id,
              display_name: {
                th: mec2.display_name.th,
                en: mec2.display_name.en,
              },
              value: {
                id: mec2ValueId,
                display_name: mec2ValueDisplayName,
              },
            }
            sku_mechanics.push(tempMec2)
          }

          let mechanic_3 =
            data.mechanic_3 == undefined
              ? ''
              : data.mechanic_3.toString().trim()
          let mec3Value =
            data.mechanic_value_3 == undefined
              ? ''
              : data.mechanic_value_3.toString().trim()

          let mec3Split = mechanic_3.split(':')
          let mec3 = this.option_sku_mechanic_default.find(
            w => w.display_name.th == mec3Split[0].trim()
          )
          if (mec3 && mec3 != undefined) {
            let mec3ValueId = ''
            let mec3ValueDisplayName = {
              th: '',
              en: '',
            }
            if (mec3.option_values && mec3.option_values.length > 0) {
              let checkMec3Value = mec3.option_values.find(
                w => w.display_name.th == mec3Value
              )
              if (checkMec3Value && checkMec3Value != undefined) {
                mec3ValueId = checkMec3Value.id
                mec3ValueDisplayName = checkMec3Value.display_name
              }
            } else {
              mec3ValueDisplayName.th = mec3Value
              mec3ValueDisplayName.en = mec3Value
            }
            let tempMec3 = {
              id: mec3.id,
              display_name: {
                th: mec3.display_name.th,
                en: mec3.display_name.en,
              },
              value: {
                id: mec3ValueId,
                display_name: mec3ValueDisplayName,
              },
            }
            sku_mechanics.push(tempMec3)
          }

          let mechanic_4 =
            data.mechanic_4 == undefined
              ? ''
              : data.mechanic_4.toString().trim()
          let mec4Value =
            data.mechanic_value_4 == undefined
              ? ''
              : data.mechanic_value_4.toString().trim()
          let mec4Split = mechanic_4.split(':')
          let mec4 = this.option_sku_mechanic_default.find(
            w => w.display_name.th == mec4Split[0].trim()
          )
          if (mec4 && mec4 != undefined) {
            let mec4ValueId = ''
            let mec4ValueDisplayName = {
              th: '',
              en: '',
            }
            if (mec4.option_values && mec4.option_values.length > 0) {
              let checkMec4Value = mec4.option_values.find(
                w => w.display_name.th == mec4Value
              )
              if (checkMec4Value && checkMec4Value != undefined) {
                mec4ValueId = checkMec4Value.id
                mec4ValueDisplayName = checkMec4Value.display_name
              }
            } else {
              mec4ValueDisplayName.th = mec4Value
              mec4ValueDisplayName.en = mec4Value
            }
            let tempMec4 = {
              id: mec4.id,
              display_name: {
                th: mec4.display_name.th,
                en: mec4.display_name.en,
              },
              value: {
                id: mec4ValueId,
                display_name: mec4ValueDisplayName,
              },
            }
            sku_mechanics.push(tempMec4)
          }

          let tempAttributes = {
            id: '',
            display_name: {
              th: '',
              en: '',
            },
            attributes: [],
          }
          let data_attribute_set =
            data.attribute_set == undefined
              ? ''
              : data.attribute_set.toString().trim()
          let attribute_set = this.attributeSetGroupProductSelectList.find(
            w => w.value.th == data_attribute_set
          )
          if (attribute_set && attribute_set != undefined) {
            tempAttributes.id = attribute_set.id
            tempAttributes.display_name = attribute_set.value
            for (var p in propertyExcel) {
              let attributes = attribute_set.attributes.find(
                w => w.id == propertyExcel[p]
              )
              if (attributes && attributes != undefined) {
                let value = {
                  th: '',
                  en: '',
                }
                let dataAttributes = data[propertyExcel[p]]
                if (
                  attributes.type == 'Multiple Select' ||
                  attributes.type == 'Dropdown'
                ) {
                  let dataAttributesSplit = dataAttributes.split(':')
                  if (dataAttributesSplit.length == 2) {
                    value.th = dataAttributesSplit[0].trim()
                    value.en = dataAttributesSplit[1].trim()
                  } else {
                    value.th = dataAttributesSplit[0].trim()
                    value.en = dataAttributesSplit[0].trim()
                  }
                } else if (attributes.type == 'Boolean') {
                  if (dataAttributes == 'Yes') {
                    value.th = 'ใช่'
                    value.en = 'Yes'
                  } else if (dataAttributes == 'No') {
                    value.th = 'ไม่ใช่'
                    value.en = 'No'
                  }
                } else {
                  value.th =
                    dataAttributes != null
                      ? dataAttributes.toString().trim()
                      : ''
                  value.en =
                    dataAttributes != null
                      ? dataAttributes.toString().trim()
                      : ''
                }
                var at = {
                  sequence: attributes.sequence,
                  id: attributes.id,
                  display_name: attributes.display_name,
                  value: value,
                }
                tempAttributes.attributes.push(at)
              }
            }
          }

          let warehouse =
            data.warehouse == undefined ? '' : data.warehouse.toString().trim()
          let sub_warehouse =
            data.sub_warehouse == undefined
              ? ''
              : data.sub_warehouse.toString().trim()
          let warehouse_id = ''
          let sub_warehouse_id = ''

          let checkWareHouse = this.excel.warehouseOptions.find(
            w => w.warehouse_name == warehouse
          )
          if (checkWareHouse && checkWareHouse != undefined) {
            warehouse_id = checkWareHouse.warehouse_id
            if (
              checkWareHouse.sub_warehouses &&
              checkWareHouse.sub_warehouses != undefined
            ) {
              let check_sub_warehouse = checkWareHouse.sub_warehouses.find(
                w => w.sub_warehouse_name == sub_warehouse
              )
              if (check_sub_warehouse && check_sub_warehouse != undefined) {
                sub_warehouse_id = check_sub_warehouse.sub_warehouse_id
              }
            }
          }

          let pre_order_start_date = ''
          if (data.pre_order_start_date != undefined) {
            let pre_start = ''
            if (typeof data.pre_order_start_date == 'number') {
              pre_start = this.ExcelDateToJSDate(
                data.pre_order_start_date.toString().trim()
              )
              console.log('pre_order start', pre_start)
            } else {
              try {
                let start_date = data.pre_order_start_date
                  .toString()
                  .trim()
                  .split('/')
                if (start_date.length == 3) {
                  pre_start =
                    start_date[1] + '/' + start_date[0] + '/' + start_date[2]
                }
              } catch {
                pre_start = ''
              }
            }
            pre_order_start_date =
              ToISOString(pre_start) == 'Invalid Date'
                ? ''
                : ToISOString(pre_start)
            console.log('pre_order start2', pre_order_start_date)
          }
          let pre_order_end_date = ''
          if (data.pre_order_end_date != undefined) {
            let pre_end = ''
            if (typeof data.pre_order_end_date == 'number') {
              pre_end = this.ExcelDateToJSDate(
                data.pre_order_end_date.toString().trim()
              )
              console.log('pre_order end', pre_end)
            } else {
              try {
                let end_date = data.pre_order_end_date
                  .toString()
                  .trim()
                  .split('/')
                if (end_date.length == 3) {
                  pre_end = end_date[1] + '/' + end_date[0] + '/' + end_date[2]
                }
              } catch {
                pre_end = ''
              }
            }
            pre_order_end_date =
              ToISOString(pre_end) == 'Invalid Date' ? '' : ToISOString(pre_end)
            console.log('pre_order end2', pre_order_end_date)
          }
          let delivery_start_date = ''
          if (data.delivery_start_date != undefined) {
            let delivery_date = ''
            if (typeof data.delivery_start_date == 'number') {
              delivery_date = this.ExcelDateToJSDate(
                data.delivery_start_date.toString().trim()
              )
            } else {
              try {
                let sp_delivery_date = data.delivery_start_date
                  .toString()
                  .trim()
                  .split('/')
                if (sp_delivery_date.length == 3) {
                  delivery_date =
                    sp_delivery_date[1] +
                    '/' +
                    sp_delivery_date[0] +
                    '/' +
                    sp_delivery_date[2]
                }
              } catch {
                delivery_date = ''
              }
            }
            delivery_start_date =
              ToISOString(delivery_date) == 'Invalid Date'
                ? ''
                : ToISOString(delivery_date)
            console.log('pre_order delivery2', delivery_start_date)
          }

          let image_array = []

          for (let i = 0; i < 10; i++) {
            let image_url = `image_url_${i}`
            if (data[image_url] != undefined) {
              image_array.push(data[image_url].toString().trim())
            }
          }

          let temp = {
            id: index,
            hybrid_category: {
              id: hybrid_category_id,
            },
            brand_name: {
              id: branID,
              display_name: {
                th: brandName.th,
                en: brandName.en,
              },
            },
            series_name: {
              display_name: {
                th:
                  data.series_name_th == undefined
                    ? ''
                    : data.series_name_th.toString().trim(),
                en:
                  data.series_name_en == undefined
                    ? ''
                    : data.series_name_en.toString().trim(),
              },
            },
            product_name: {
              display_name: {
                th:
                  data.product_name_th == undefined
                    ? ''
                    : data.product_name_th.toString().trim(),
                en:
                  data.product_name_en == undefined
                    ? ''
                    : data.product_name_en.toString().trim(),
              },
            },
            unit: {
              id: unitID,
              display_name: {
                th: unitdName.th,
                en: unitdName.en,
              },
            },
            sku_mechanics: sku_mechanics,
            sku_code: {
              jda:
                data.sku_code_jda == undefined
                  ? ''
                  : data.sku_code_jda.toString().trim(),
              b2s:
                data.sku_code_b2s == undefined
                  ? ''
                  : data.sku_code_b2s.toString().trim(),
              vendor:
                data.sku_code_vendor == undefined
                  ? ''
                  : data.sku_code_vendor.toString().trim(),
            },
            barcode: {
              vendor:
                data.barcode_vendor == undefined
                  ? ''
                  : data.barcode_vendor.toString().trim(),
              ofm:
                data.barcode_ofm == undefined
                  ? ''
                  : data.barcode_ofm.toString().trim(),
            },
            is_vat:
              data.is_vat == undefined
                ? ''
                : data.is_vat.toString().trim() == 'Yes'
                ? true
                : data.is_vat.toString().trim() == 'No'
                ? false
                : null,
            fix_price_period:
              data.fix_price_period == undefined
                ? ''
                : data.fix_price_period.toString().trim(),
            discount_rate:
              data.discount_rate == undefined || data.discount_rate == ''
                ? 0.0
                : data.discount_rate.toString().trim(),
            cost_price_exc_vat:
              data.cost_price_exc_vat == undefined ||
              data.cost_price_exc_vat == ''
                ? 0.0
                : data.cost_price_exc_vat.toString().trim(),
            full_price_inc_vat:
              data.full_price_inc_vat == undefined ||
              data.full_price_inc_vat == ''
                ? 0.0
                : data.full_price_inc_vat.toString().trim(),
            sale_price_inc_vat:
              data.sale_price_inc_vat == undefined ||
              data.sale_price_inc_vat == ''
                ? 0.0
                : data.sale_price_inc_vat.toString().trim(),
            is_best_deal:
              data.is_best_deal == undefined
                ? ''
                : data.is_best_deal.toString().trim() == 'Yes'
                ? true
                : data.is_best_deal.toString().trim() == 'No'
                ? false
                : null,
            pack_size:
              data.pack_size == undefined || data.pack_size == ''
                ? 0
                : data.pack_size.toString().trim(),
            limit_order_minimum:
              data.limit_order_minimum == undefined ||
              data.limit_order_minimum == ''
                ? 0
                : data.limit_order_minimum.toString().trim(),
            limit_order_maximum:
              data.limit_order_maximum == undefined ||
              data.limit_order_minimum == ''
                ? 0
                : data.limit_order_maximum.toString().trim(),
            product_status_inventory:
              data.product_status_inventory == undefined
                ? ''
                : data.product_status_inventory.toString().trim(),
            jda_status:
              data.jda_status == undefined
                ? ''
                : data.jda_status.toString().trim(),
            jda_special_type:
              data.jda_special_type == undefined
                ? ''
                : data.jda_special_type.toString().trim(),
            image_urls: image_array.count == 0 ? null : image_array,
            content_short_description: {
              th:
                data.content_short_description_th == undefined
                  ? ''
                  : data.content_short_description_th.toString().trim(),
              en:
                data.content_short_description_en == undefined
                  ? ''
                  : data.content_short_description_en.toString().trim(),
            },
            content_long_description: {
              th:
                data.content_long_description_th == undefined
                  ? ''
                  : data.content_long_description_th.toString().trim(),
              en:
                data.content_long_description_en == undefined
                  ? ''
                  : data.content_long_description_en.toString().trim(),
            },
            delivery_lead_time:
              data.delivery_lead_time == undefined
                ? ''
                : data.delivery_lead_time.toString().trim(),
            delivery_start_date: delivery_start_date,
            weight_g:
              data.weight_g == undefined || data.weight_g == ''
                ? 0
                : data.weight_g.toString().trim(),
            width_mm:
              data.width_mm == undefined || data.width_mm == ''
                ? 0
                : data.width_mm.toString().trim(),
            length_mm:
              data.length_mm == undefined || data.length_mm == ''
                ? 0
                : data.length_mm.toString().trim(),
            height_mm:
              data.height_mm == undefined || data.height_mm == ''
                ? 0
                : data.height_mm.toString().trim(),
            is_ofm_delivery:
              data.is_ofm_delivery == undefined
                ? null
                : data.is_ofm_delivery.toString().trim() == 'Yes'
                ? true
                : data.is_ofm_delivery.toString().trim() == 'No'
                ? false
                : null,
            warehouse: warehouse_id,
            sub_warehouse: sub_warehouse_id,
            has_new_product_fee:
              data.has_new_product_fee == undefined
                ? null
                : data.has_new_product_fee.toString().trim() == 'Yes'
                ? true
                : data.has_new_product_fee.toString().trim() == 'No'
                ? false
                : null,
            is_return_to_vendor:
              data.is_return_to_vendor == undefined
                ? null
                : data.is_return_to_vendor.toString().trim() == 'Yes'
                ? true
                : data.is_return_to_vendor.toString().trim() == 'No'
                ? false
                : null,
            aging:
              data.aging == undefined || data.aging == ''
                ? 0
                : data.aging.toString().trim(),
            type: data.type == undefined ? '' : data.type.toString().trim(),
            is_import:
              data.is_import == undefined
                ? null
                : data.is_import.toString().trim() == 'Yes'
                ? true
                : data.is_import.toString().trim() == 'No'
                ? false
                : null,
            is_bidding_price:
              data.is_bidding_price == undefined
                ? null
                : data.is_bidding_price.toString().trim() == 'Yes'
                ? true
                : data.is_bidding_price.toString().trim() == 'No'
                ? false
                : null,
            is_hamper:
              data.is_hamper == undefined
                ? null
                : data.is_hamper.toString().trim() == 'Yes'
                ? true
                : data.is_hamper.toString().trim() == 'No'
                ? false
                : null,
            has_consumer_protection:
              data.has_consumer_protection == undefined
                ? null
                : data.has_consumer_protection.toString().trim() == 'Yes'
                ? true
                : data.has_consumer_protection.toString().trim() == 'No'
                ? false
                : null,
            is_virtual_stock:
              data.is_virtual_stock == undefined
                ? null
                : data.is_virtual_stock.toString().trim() == 'Yes'
                ? true
                : data.is_virtual_stock.toString().trim() == 'No'
                ? false
                : null,
            pre_order_start_date: pre_order_start_date,
            pre_order_end_date: pre_order_end_date,
            vendor_remark:
              data.vendor_remark == undefined
                ? ''
                : data.vendor_remark.toString().trim(),
            attribute: tempAttributes,
            document_file:
              data.document_file == undefined
                ? ''
                : data.document_file.toString().trim(),
            substitute:
              data.substitute == undefined
                ? ''
                : data.substitute.toString().trim(),
            business_unit:
              data.business_unit == undefined
                ? ''
                : data.business_unit.toString().split(','),
          }
          dataValidate.push(temp)
        })
      }
      return dataValidate
    },
    async validateImportDataExcel2(items) {
      var params = {
        vendor_id: this.vendorComponentModel.model.id,
        product_details: items,
      }
      var result = null

      if (this.vendorComponentModel.model.vendor_type === 'OFMStock') {
        result = await requestDocumentService.validateProductRegisterOFMStockAsync(
          params
        )
      } else {
        result = await requestDocumentService.validateProductRegisterDropShipAsync(
          params
        )
      }

      return result
    },
    async validateImportDataExcel(items) {
      this.validateImportError = false

      var params = {
        vendor_id: this.vendorComponentModel.model.id,
        product_details: items,
      }
      var result = null

      if (this.vendorComponentModel.model.vendor_type === 'OFMStock') {
        result = await requestDocumentService.validateProductRegisterOFMStockAsync(
          params
        )
      } else {
        result = await requestDocumentService.validateProductRegisterDropShipAsync(
          params
        )
      }

      if (result.status === 201) {
        this.items = result.data.product_details
        var countInvalid = 0

        result.data.product_details.forEach(productItem => {
          productItem.skus.forEach(skuItem => {
            if (skuItem.remark !== null) countInvalid++
          })
        })

        if (result.data.product_details.length === 0) {
          this.validateImportSuccess = false
          this.$utils.notification(
            'error',
            'ไม่พบข้อมูลกรุณาตรวจสอบไฟล์ข้อมูลให้ถูกต้อง',
            1500
          )
        } else if (countInvalid != 0) this.validateImportSuccess = false
        else this.validateImportSuccess = true
        // console.log(result.data.product_details)
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notificationAck(
          'error',
          'ไม่สามารถดำเนินการได้',
          result.response.data.message
        )
        this.onClear()
      } else {
        this.$utils.notification('error', 'ไม่สามารถดำเนินการได้', 1500)
        this.onClear()
      }

      console.log(result)
    },
    async onFiltered(filteredItems) {
      this.totalPages = filteredItems.length
    },
    async onGetAttributeSetsSelector() {
      this.attributeSetGroupProductSelectList = []
      let params = new URLSearchParams()
      params.append('pageSize', 99999)
      params.append('sort', 'display_name.en display_name.th')
      params.append('status', StatusEnum.ACTIVE)
      params.append('isGetIncludeAttributes', true)
      let result = await attributesetsService.getAttributeSetsMasterListAsync(
        params
      )
      if (result.status === 200) {
        console.log(result.data.items)
        // let attributsetItems = []
        result.data.items.forEach((element, index) => {
          this.attributeSetGroupProductSelectList.push({
            id: element.id,
            value: {
              th: element.display_name.th,
              en: element.display_name.en,
            },
            attributes: element.attributes,
          })
        })
      } else {
        if (result.response.data.message) {
          console.log(result.response.data.message)
        }
      }
    },
    async onGetVendorByIdAsync() {
      let result = await vendorService.getVendorMasterDetailAsync(
        this.GET_VENDOR_SELECTED.id
      )
      if (result.status === 200) {
        if (result.data) {
          let vendorData = result.data
          if (vendorData.status == 'Active' || vendorData.status == 'Suspend') {
            this.vendorComponentModel.model.id = vendorData.id
            this.vendorComponentModel.model.display_name =
              vendorData.display_name
            this.vendorComponentModel.model.vendor_type = vendorData.type
            this.vendorComponentModel.model.vendor_status = vendorData.status
            this.vendorComponentModel.model.lead_time = vendorData.lead_time
            this.vendorComponentModel.model.is_consignment =
              vendorData.is_consignment
            this.vendorComponentModel.model.is_import = vendorData.is_import
            this.vendorComponentModel.model.discount_rate_1 =
              vendorData.discount.rate_1
            this.vendorComponentModel.validateState = true
            this.vendorComponentModel.model.code = vendorData.vendor_partners.find(
              f => f.partner === 'OFM'
            ).code
            // this.modelChanged()
          } else {
            this.$utils.notification(
              'warning',
              `ผู้ขายมีสถานะเป็น (${vendorData.status}) ไม่สามารถทำการ Register ข้อมูลสินค้าได้`,
              2000
            )
          }
        } else {
          this.$utils.notification(
            'warning',
            `ไม่พบผู้ขายที่มีรหัส (${this.vendorComponentModel.model.code.trim()}) ในระบบ PIM`,
            2000
          )
        }
      } else {
        console.log('error', result.response.data.message)
      }
    },
    async onGetVendorDataAsync() {
      let params = new URLSearchParams()
      params.append(
        'keyword',
        this.vendorComponentModel.model.code.trim() || ''
      )
      let result = await vendorService.getVendorMasterListAsync(params)
      if (result.status === 200) {
        if (result.data.items && result.data.items.length > 0) {
          let vendorData = result.data.items[0]
          if (vendorData.status == 'Active' || vendorData.status == 'Suspend') {
            this.vendorComponentModel.model.id = vendorData.id
            this.vendorComponentModel.model.display_name =
              vendorData.display_name
            this.vendorComponentModel.model.vendor_type = vendorData.type
            this.vendorComponentModel.model.vendor_status = vendorData.status
            this.vendorComponentModel.model.lead_time = vendorData.lead_time
            this.vendorComponentModel.model.is_consignment =
              vendorData.is_consignment
            this.vendorComponentModel.model.is_import = vendorData.is_import
            this.vendorComponentModel.model.discount_rate_1 =
              vendorData.discount.rate_1
            this.vendorComponentModel.validateState = true
            // this.vendorComponentModel.vendor.id = this.vendorComponentModel.model.code

            if (this.isFirstLoad) {
              await this.onGetDataExportExcel()
              this.isFirstLoad = false
            }
          } else {
            this.$utils.notification(
              'warning',
              `ผู้ขายมีสถานะเป็น (${vendorData.status}) ไม่สามารถทำการ Register ข้อมูลสินค้าได้`,
              2000
            )
          }
        } else {
          this.$utils.notification(
            'warning',
            `ไม่พบผู้ขายที่มีรหัส (${this.vendorComponentModel.model.code.trim()}) ในระบบ PIM`,
            2000
          )
        }
      } else {
        console.log('error', result.response.data.message)
      }
    },
    onClear() {
      this.file = []
      this.items = []
      this.validateImportSuccess = false
      this.itemSuccess = []
      this.itemFailed = []
      this.dataTempExcelDarft = []
      this.dataTempExcel = []
      this.dataTempExcelRI = []
      this.attributeListDistinct = []
    },
    onClearItem(flag) {
      if (flag == 'Success') {
        //
        this.itemSuccess = []
      } else {
        //
        this.itemFailed = []
      }
    },
    async onSave(flag) {
      console.log('this.itemFailed', this.itemFailed)
      this.dataTempExcel = []
      this.flagModal = flag
      var dataTask = []
      const vm = this
      if (flag == 'darft') {
        this.dataTempExcelDarft = []
        if (
          this.itemFailed &&
          this.itemFailed.filter(w => w.np_id == undefined).length > 0
        ) {
          this.$bvModal.show('modal-option-excel-darft')
          this.itemFailed
            .filter(w => w.np_id == undefined)
            .forEach((item, index) => {
              let dataPlayload = item.data_temp
              let temp = {
                index: index + 1,
                np_id: '',
                group_id: item.group_id,
                product_name_th: dataPlayload[0].product_name.display_name.th,
                product_name_en: dataPlayload[0].product_name.display_name.en,
                status: 'loading',
                action: '',
                temp: dataPlayload,
                response: '',
                temp_data_import: item.temp_data_import,
              }
              this.dataTempExcelDarft.push(temp)
              let task1 = () => {
                return new Promise(async (resolve, reject) => {
                  var params = {
                    vendor_id: this.vendorComponentModel.model.id,
                    product_details: item.data_temp,
                  }
                  var result = null
                  try {
                    if (
                      this.vendorComponentModel.model.vendor_type === 'OFMStock'
                    ) {
                      result = await productRegisterDraftService.createProductRegisterDraftsImportOFMStockAsync(
                        params
                      )
                    } else {
                      params.vendor_code = this.vendorComponentModel.model.code
                      result = await productRegisterDraftService.createProductRegisterDraftsImportDropShipAsync(
                        params
                      )
                    }
                    console.log('result onSave', result)
                  } catch (error) {
                    // code to handle errors goes here
                    console.log('error onSave', error)
                  }
                  resolve({
                    id: item.group_id,
                    response: result,
                    playload: item,
                  })
                })
              }
              dataTask.push(task1())
            })
        }
        console.log('dataTask onSave', dataTask)

        Promise.all(dataTask).then(results => {
          console.log(results)
          let isSuccess = true
          if (results && results.length > 0) {
            for (let i = 0; i < results.length; i++) {
              let data = vm.dataTempExcelDarft.find(
                w => w.group_id == results[i].id
              )
              console.log('rs', results[i], data)
              if (data && data != undefined) {
                data.status = results[i].response.status
                data.temp = results[i].playload
                data.response = results[i].response
              }
              if (results[i].response.status != 201) {
                isSuccess = false
              } else {
                if (data && data != undefined) {
                  if (
                    results[i].response.data.np_id &&
                    results[i].response.data.np_id != ''
                  ) {
                    Vue.set(data, 'np_id', results[i].response.data.np_id)
                    //data.np_id = results[i].response.data.np_id

                    let itemFaild = vm.itemFailed.find(
                      w => w.group_id == results[i].id
                    )
                    if (itemFaild && itemFaild != undefined) {
                      Vue.set(
                        itemFaild,
                        'np_id',
                        results[i].response.data.np_id
                      )
                      //itemFaild.np_id = results[i].response.data.np_id
                    }
                    console.log('tan', vm.itemFailed)
                  } else {
                    isSuccess = false
                  }
                }
              }
            }
          }
          if (isSuccess) {
            this.$bvModal.hide('modal-option-excel-darft')
          }
        })
      } else {
        this.dataTempExcelRI = []
        if (
          this.itemSuccess &&
          this.itemSuccess.filter(w => w.ri_id == undefined).length > 0
        ) {
          this.$bvModal.show('modal-option-excel-ri')
          let itemSucessFilter = this.itemSuccess.filter(
            w => w.ri_id == undefined
          )
          for (let index = 0; index < itemSucessFilter.length; index++) {
            let item = itemSucessFilter[index]
            let dataPlayload = item.data_temp
            let temp = {
              key: item.key,
              index: index + 1,
              ri_id: '',
              group_id: item.group_id,
              product_name_th: dataPlayload[0].product_name.display_name.th,
              product_name_en: dataPlayload[0].product_name.display_name.en,
              status: 'loading',
              action: '',
              temp: dataPlayload,
              response: '',
              temp_data_import: item.temp_data_import,
            }
            this.dataTempExcelRI.push(temp)
            let task1 = () => {
              return new Promise(async (resolve, reject) => {
                var params = {
                  vendor_id: this.vendorComponentModel.model.id,
                  product_details: item.data_temp,
                  vendor_code: this.vendorComponentModel.model.code,
                }

                var delayInMilliseconds = Math.floor(Math.random() * 3000) + 3

                setTimeout(async function() {
                  var result = await productRegisterService.createImportApproveProductRegisterAsync(
                    params
                  )
                  resolve({
                    id: item.key,
                    group_id: item.group_id,
                    response: result,
                    playload: item,
                  })
                }, delayInMilliseconds)
              })
            }
            dataTask.push(task1())
          }

          Promise.all(dataTask).then(results => {
            let isSuccess = true
            if (results && results.length > 0) {
              for (let i = 0; i < results.length; i++) {
                let data = this.dataTempExcelRI.find(
                  w => w.key == results[i].id
                )
                if (data && data != undefined) {
                  data.status = results[i].response.status
                  data.temp = results[i].playload
                  data.response = results[i].response
                }

                let itemSuccess = this.itemSuccess.find(
                  w => w.key == results[i].id
                )
                if (results[i].response.status != 201) {
                  isSuccess = false
                  if (itemSuccess && itemSuccess != undefined) {
                    //
                    itemSuccess.data_explain.forEach(item => {
                      item.remark = [results[i].response.message]
                    })
                  }
                } else {
                  if (data && data != undefined) {
                    if (
                      results[i].response.data.id &&
                      results[i].response.data.id != ''
                    ) {
                      data.ri_id = results[i].response.data.id
                      if (itemSuccess && itemSuccess != undefined) {
                        Vue.set(
                          itemSuccess,
                          'ri_id',
                          results[i].response.data.id
                        )
                        //itemSuccess.ri_id = results[i].response.data.id
                      }
                    } else {
                      isSuccess = false
                    }
                  }
                }
              }
            }
            if (isSuccess) {
              this.$bvModal.hide('modal-option-excel-ri')
            }
          })
        }
      }
    },
    async onGetWarehouseItemsSelector() {
      let params = new URLSearchParams()
      params.append('pageSize', 999999)
      params.append('sort', 'warehouse_name')
      let result = await warehouseService.getWarehouseListAsync(params)
      if (result.status === 200) {
        let warehouseItems = []
        result.data.items.forEach((element, index) => {
          warehouseItems[index] = {
            warehouse_id: element.id,
            warehouse_name: element.warehouse_name,
            sub_warehouses: element.sub_warehouses,
          }
        })
        this.excel.warehouseOptions = warehouseItems
      } else {
        if (result.response.data.message) {
          console.log(result.response.data.message)
        } else {
          console.log('Bad request: Unkonw error')
        }
      }
    },
    async onGetDataExportExcel() {
      this.disabledBtnUpload = true
      await this.onGetBrandSelector()
      await this.getHybridCategory()
      await this.onGetAttributeSetsSelector()
      await this.onGetWarehouseItemsSelector()
      await this.onGetUnitSelector()
      await this.onGetColorSelector()
      await this.onGetAttributeSkuMechanicSelector()
      this.disabledBtnUpload = false
    },
    async onClickPagination(event, flag) {
      //this.multitask()
      if (flag == 'ri') {
        this.optionsValid.pageNo = event
      } else {
        this.optionsValidDarft.pageNo = event
      }
    },
    async onChangePerPage(event, flag) {
      //this.multitask()
      if (flag == 'ri') {
        this.optionsValid.perPage = event
      } else {
        this.optionsValidDarft.perPage = event
      }
    },
    async delay(ms) {
      return new Promise(resolve => {
        setTimeout(resolve, ms)
      })
    },
    async multitask() {
      console.log('Starting task 1')
      this.delay(2000).then(() => {
        console.log('Task 1 finished')
      })

      console.log('Starting task 2')
      this.delay(1000).then(() => {
        console.log('Task 2 finished')
      })

      console.log('Starting task 3')
      this.delay(3000).then(() => {
        console.log('Task 3 finished')
      })
    },
  },

  errorUploadExcel(msg) {
    this.loadingModelText = null
    this.progressValue = 0
    this.$utils.notification('error', `<small> ${msg} </small>`, 5000)
  },
}
</script>
<style scoped>
.color-red {
  color: red;
}
.color-green {
  color: green;
}

.loader {
  color: #000;
  position: relative;
  display: inline-block;
  margin-top: 20px;
  font-family: Kanit;
  font-size: 30px;
  letter-spacing: 4px;
  box-sizing: border-box;
  opacity: 0.8;
}

.loader::before {
  content: '';
  box-sizing: border-box;
  position: absolute;
  right: 31px;
  bottom: 20px;
  height: 20px;
  width: 5px;
  border-radius: 18%;
  background: currentColor;
  animation: animloader1 1s ease-in infinite;
}

.loader::after {
  content: '';
  width: 8px;
  height: 8px;
  position: absolute;
  left: 22px;
  top: -5px;
  border-radius: 50%;
  background: red;
  box-sizing: border-box;
  animation: animloader 1s ease-in infinite;
}

@keyframes animloader {
  0% {
    transform: translateY(8px) scaleY(1) scaleX(1.25);
  }

  25%,
  75% {
    transform: translateY(-5px) scaleY(1.2) scaleX(1);
  }

  50% {
    transform: translateY(-10px) scaleY(1) scaleX(1);
  }

  100% {
    transform: translateY(8px) scaleY(0.8) scaleX(0.8);
  }
}

@keyframes animloader1 {
  0% {
    transform: translateY(8px) scaleY(1) scaleX(0.8);
    background: #1565c0;
  }

  100% {
    transform: translateY(8px) scaleY(0.8) scaleX(1);
  }
}
</style>
